import * as React from 'react';
import * as ReactDom from 'react-dom';
import $ from 'jquery';
import { PopupWindow } from './../sharedcomponents/PopupWindow';
import * as Exceljs from '../../actions/ExportToExcel.js';
import { RCUtils } from './../../RCUtils';
import Workbook from 'react-excel-workbook';
import Formatters from '../../actions/Formatters';
import reeferFormatters from '../../actions/ReeferFormatter';
var Config: any = require('../../Config.json');
var optionId;
var Excel = Exceljs.default;

//var exportCols: any[];

interface ToolBarState {
    renderEmailHtml: any;
    renderGridPreferenceHtml: any;
    modelDialogHtml: any;
    exportFields: ExportFields;
    excelData: any[];
    headerData: any[];
    isDownload: boolean;
    excelGridData: any[];
    formName: string;
    fileTitle: string;
    sheetInfo: any;
    renderExportToExcel: any;


    exportColumns: any[];
    targetKeys: any[];
    colDefs: any[];
    isUserPreference: boolean;
    selectedOption: any;
    isIncludeRowGroup: boolean;
    gridApiParams: any;
    onlyselected: boolean;
    isIncludeColumnGroup: boolean;
    SheetName: string;
    sensorData: any[];
}

class ReeferHistoryFilter {
    FromDate: string;
    ToDate: string;
    Units: string;
}
class ExportFields {
    ExportData: string;
}

var columnsToBeExported: any;
var self;
var ProcessfirstCellOnlyRowIndex = -1;

export class ExportToExcelConfirmationWindow extends React.Component<any, ToolBarState> {
    constructor(props: any) {
        super(props);
        var filterSet = new ReeferHistoryFilter();
        var exportData = new ExportFields();
        this.state = {
            renderEmailHtml: '', modelDialogHtml: '', exportFields: exportData, excelData: [], headerData: [], isDownload: false, excelGridData: this.props.gridData,
            formName: this.props.formName, fileTitle: this.GetExportFileName(), sheetInfo: '', renderGridPreferenceHtml: '', renderExportToExcel: '', SheetName: ''

            , exportColumns: [], targetKeys: [], colDefs: this.props.colDefs
            , isUserPreference: false, selectedOption: '',
            isIncludeRowGroup: this.props.gridApiParams.gridOptionsWrapper == null ? false : this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false, //RCNG-207
            gridApiParams: this.props.gridApiParams,
            onlyselected: this.props.onlyselected != null && this.props.onlyselected != undefined ? this.props.onlyselected : false,
            isIncludeColumnGroup: true, sensorData: this.props.sensorData
        };

        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.onChangeIncludeRowGroup = this.onChangeIncludeRowGroup.bind(this);
        //this.getOtherColumnCellValue = this.getOtherColumnCellValue.bind(this);
        //this.myRowGroupCallback = this.myRowGroupCallback.bind(this);
        this.getGroupDisplayValueName = this.getGroupDisplayValueName.bind(this);
        self = this;

    }

    static clearOptionFilters() {
        var ele = document.getElementsByName("options");
        for (var i = 0; i < ele.length; i++) {
            var elementOfi = document.getElementsByName("options")[i] as HTMLInputElement;
            elementOfi.checked = false;

        }

        //$('#option1:checked').removeAttr('checked');
        //$('#option2:checked').removeAttr('checked');
    }
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.functionId != 'undefined' && nextProps.functionId != undefined && nextProps.functionId != 0) {
            this.IsUserPreference(nextProps.dashboardPreferenceId, nextProps.widgetId);
        }
        this.setState({
            isIncludeRowGroup: nextProps.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false,
            gridApiParams: nextProps.gridApiParams,
            excelGridData: nextProps.gridData,
            onlyselected: nextProps.onlyselected != null && nextProps.onlyselected != undefined ? nextProps.onlyselected : false,
            isIncludeColumnGroup: nextProps.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false,
            sensorData: nextProps.sensorData
        });
    }

    IsUserPreference(dashboardPreferenceId: any, widgetId: any) {
        if (dashboardPreferenceId != 'undefined' && dashboardPreferenceId != undefined && dashboardPreferenceId != 0) {
            var preferenceParams: any = { WidgetId : widgetId, DashboardPreferenceId: dashboardPreferenceId };
            var url = Config.ApiBaseUrl + '/api/User/IsUserPreference';//this.props.functionId;
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferenceParams), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'} });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<boolean>)
                .then(data => {
                    if (data != null && data === false) {
                        //optionId = 1;
                        this.setState({ isUserPreference: false, selectedOption: 'AllColumns' });
                    }
                    else {
                        //optionId = 2;
                        this.setState({ isUserPreference: true, selectedOption: 'SelectedColumns' });
                    }
                });
        }

    }

    componentDidMount() {
        this.IsUserPreference(this.props.dashboardPreferenceId, this.props.widgetId)
        this.renderSheets();
    }
    yes() {

        if (this.Validation()) {

            if (this.state.selectedOption === 'SelectedColumns') {
                optionId = 2;
            }
            else if (this.state.selectedOption === 'AllColumns') {
                optionId = 1;
            }


            if (optionId == 2) {
                var dbPreID: any = sessionStorage.getItem('DashboardPreferenceId'); //RCNG 5353 Fix
                var url = Config.ApiBaseUrl + '/api/User/GetCustomerPreferenceData?FunctionId=' + this.props.functionId + '&DashboardPreferenceId=' + dbPreID;
                var request = RCUtils.FetchRequest(url, {
                    method: 'GET',
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
                });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<any>)
                    .then(data => {
                        var columnNames = null;

                        var gridPreferencesData: any = null;
                        if (data != null && data.dashboardLayoutPreferences != null && data.dashboardLayoutPreferences.DashboardWidgetsSearch != null)
                            gridPreferencesData= data.dashboardLayoutPreferences.DashboardWidgetsSearch.filter(x => x.DashboardWidgetId == this.props.widgetId);

                            if (gridPreferencesData != null && gridPreferencesData.length > 0) {
                            var preferenceData = JSON.parse(gridPreferencesData[0].SearchData);
                            if (preferenceData.SelectedColumnValues != "" && preferenceData.SelectedColumnValues != null) {
                                var userColumnNames = preferenceData.SelectedColumnValues;
                                if (data.CustomerPreference != null) {
                                    var customerPreference = JSON.parse(data.CustomerPreference);
                                    var customerSelectedColumns = customerPreference.SelectedColumnValues;
                                    columnNames = userColumnNames.filter(value => -1 !== customerSelectedColumns.indexOf(value));
                                }
                                //else
                                //    columnNames = preferenceData.SelectedColumnValues;
                                else {
                                    if (data.DefaultCustomerPreference != null) {
                                        var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                                        var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                                        defaultCustomerColumns = defaultCustomerColumns.concat(data.CustomerAttributes).concat(data.DeviceSensors);
                                        //columnNames = preferenceData.SelectedColumnValues;
                                        columnNames = userColumnNames.filter(value => -1 !== defaultCustomerColumns.indexOf(value));
                                    }
                                    else
                                        columnNames = preferenceData.SelectedColumnValues;
                                }
                                //this.ExportToExcel(columnNames, optionId);                                
                                //columnsToBeExported = preferenceData.SelectedColumnValues;
                                columnsToBeExported = columnNames;

                                if (self.state.onlyselected || this.state.onlyselected) {
                                    this.setState({ isDownload: true },
                                        () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                                            {
                                                columnGroups: false, columnKeys: columnsToBeExported, onlySelected: true,
                                                processCellCallback: this.myCellCallback, skipGroups: true,
                                                processHeaderCallback: this.myHeaderCallback,
                                                fileName: this.getFileName(this.GetExportFileName()),
                                                sheetName: this.getFileName(this.GetExportFileName()),
                                            })
                                    );
                                }
                                else if (this.state.isIncludeRowGroup && this.state.isIncludeColumnGroup) {
                                    this.setState({ isDownload: true },
                                        () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                                            {
                                                columnGroups: true,// columnKeys: columnsToBeExported,
                                                allColumns: true,
                                                processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
                                                processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
                                                fileName: this.getFileName(this.GetExportFileName()),
                                                sheetName: this.getFileName(this.GetExportFileName()),
                                            })
                                    );
                                }
                                else if (this.state.isIncludeRowGroup && !this.state.isIncludeColumnGroup) {
                                    this.setState({ isDownload: true },
                                        () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                                            {
                                                columnGroups: false, //columnKeys: columnsToBeExported,
                                                allColumns: true,
                                                processGroupHeaderCallback: this.myGroupHeaderCallback,
                                                processHeaderCallback: this.myHeaderCallback,
                                                processRowGroupCallback: this.myRowGroupCallback,
                                                processCellCallback: this.myCellCallback,
                                                fileName: this.getFileName(this.GetExportFileName()),
                                                sheetName: this.getFileName(this.GetExportFileName()),
                                            })
                                    );
                                }
                                else {

                                    this.setState({ isDownload: true },
                                        () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel({
                                            columnGroups: false, skipGroups: true,
                                            processCellCallback: this.myCellCallback,
                                            processHeaderCallback: this.myHeaderCallback,
                                            columnKeys: columnsToBeExported,
                                            fileName: this.getFileName(this.GetExportFileName()),
                                            sheetName: this.getFileName(this.GetExportFileName()),
                                        })
                                    );
                                }

                                if (this.state.isDownload) {
                                    this.showMessageAndClosePopup();
                                }
                            }
                        }
                        else {
                            PopupWindow.showErrorMessage("Alert", "No Preference setting found.");
                        }
                    });

            }
            else if (optionId == 1) {

                var customerId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;
                var url = Config.ApiBaseUrl + '/api/User/CustomerPreferenceAttachment';
                var preferencedata = {
                    CustomerId: JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId,
                    FunctionId: this.props.functionId,
                    PreferenceData: null
                }
                var request = RCUtils.FetchRequest(url, {
                    method: 'POST',
                    body: JSON.stringify(preferencedata),
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
                });

                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<server.CustomerPreferences>)
                    .then(data => {
                        if (data.PreferenceData != null || data.DefaultPreferenceData != null) {
                            //var preferenceData = JSON.parse(data.PreferenceData);
                            //this.setState({
                            //    exportColumns: preferenceData.SelectedColumnValues,
                            //    targetKeys: preferenceData.SelectedColumnIds
                            //});

                            if (data.PreferenceData != null) {
                                var customerPreferenceData = JSON.parse(data.PreferenceData);
                                var customerSelectedColumns = customerPreferenceData.SelectedColumnValues;
                                columnsToBeExported = customerSelectedColumns;
                            }
                            //else
                            //    columnNames = preferenceData.SelectedColumnValues;
                            else if (data.DefaultPreferenceData != null) {
                                var defaultCustomerPreference = JSON.parse(data.DefaultPreferenceData);
                                var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                                defaultCustomerColumns = defaultCustomerColumns.concat(data.CustomerAttributes).concat(data.DeviceSensors);
                                columnsToBeExported = defaultCustomerColumns;
                            }


                            if (this.state.onlyselected) {
                                this.setState({ isDownload: true },
                                    () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                                        {
                                            columnGroups: false, columnKeys: columnsToBeExported, onlySelected: true,
                                            processCellCallback: this.myCellCallback, skipGroups: true,
                                            processHeaderCallback: this.myHeaderCallback,
                                            fileName: this.getFileName(this.GetExportFileName()),
                                            sheetName: this.getFileName(this.GetExportFileName()),
                                        })
                                );
                            }
                            else if (this.state.isIncludeRowGroup && this.state.isIncludeColumnGroup) {
                                this.setState({ isDownload: true },
                                    () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                                        {
                                            columnGroups: true, allColumns: true,// columnKeys: columnsToBeExported,
                                            processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
                                            processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
                                            fileName: this.getFileName(this.GetExportFileName()),
                                            sheetName: this.getFileName(this.GetExportFileName()),
                                        })
                                );
                            }
                            else if (this.state.isIncludeRowGroup && !this.state.isIncludeColumnGroup) {
                                this.setState({ isDownload: true },
                                    () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                                        {
                                            columnGroups: false, allColumns: true, //columnKeys: columnsToBeExported,
                                            processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
                                            processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
                                            fileName: this.getFileName(this.GetExportFileName()),
                                            sheetName: this.getFileName(this.GetExportFileName()),
                                        })
                                );
                            }
                            else {
                                this.setState({ isDownload: true },
                                    () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel({
                                        columnGroups: false,
                                        processCellCallback: this.myCellCallback,
                                        processHeaderCallback: this.myHeaderCallback,
                                        columnKeys: columnsToBeExported, skipGroups: true,
                                        fileName: this.getFileName(this.GetExportFileName()),
                                        sheetName: this.getFileName(this.GetExportFileName()),
                                    })
                                );
                            }

                            if (this.state.isDownload) {
                                this.showMessageAndClosePopup();
                            }
                        }
                        else {

                            //All columns grid level
                            //this.ExportToExcel(null,0);
                            columnsToBeExported = null;
                            //this.setState({ isDownload: true },
                            //    () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(this.getParams())
                            //);
                            if (this.state.onlyselected) {
                                this.setState({ isDownload: true },
                                    () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                                        {
                                            columnGroups: false, allColumns: true, onlySelected: true,
                                            processCellCallback: this.myCellCallback, skipGroups: true,
                                            processHeaderCallback: this.myHeaderCallback,
                                            fileName: this.getFileName(this.GetExportFileName()),
                                            sheetName: this.getFileName(this.GetExportFileName()),
                                        })
                                );
                            }
                            else if (this.state.isIncludeRowGroup && this.state.isIncludeColumnGroup) {
                                this.setState({ isDownload: true },
                                    () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                                        {
                                            columnGroups: true, allColumns: true,
                                            processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
                                            processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
                                            fileName: this.getFileName(this.GetExportFileName()),
                                            sheetName: this.getFileName(this.GetExportFileName()),
                                        })
                                );
                            }
                            else if (this.state.isIncludeRowGroup && !this.state.isIncludeColumnGroup) {
                                this.setState({ isDownload: true },
                                    () => this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                                        {
                                            columnGroups: false, allColumns: true,
                                            processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
                                            processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
                                            fileName: this.getFileName(this.GetExportFileName()),
                                            sheetName: this.getFileName(this.GetExportFileName()),
                                        })
                                );
                            }
                            else {
                                this.setState({ isDownload: true },
                                    () => {
                                        var IsGroupsExist = this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false;
                                        if (IsGroupsExist) {
                                            this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel({
                                                columnGroups: false,
                                                processCellCallback: this.myCellCallback,
                                                processHeaderCallback: this.myHeaderCallback,
                                                allColumns: true, skipGroups: true,
                                                fileName: this.getFileName(this.GetExportFileName()),
                                                sheetName: this.getFileName(this.GetExportFileName()),
                                            });
                                        } else {
                                            var allColumns = this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                                            for (var i = allColumns.length - 1; i >= 0; i--) {
                                                if (allColumns[i].colDef.headerName === 'Group') {
                                                    allColumns.splice(i, 1);
                                                }
                                            }
                                            this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel({
                                                columnGroups: true,
                                                processCellCallback: this.myCellCallback,
                                                processHeaderCallback: this.myHeaderCallback,
                                                columnKeys: allColumns,
                                                skipGroups: true,
                                                fileName: this.getFileName(this.GetExportFileName()),
                                                sheetName: this.getFileName(this.GetExportFileName()),
                                            });
                                        }
                                    }
                                );
                            }

                            if (this.state.isDownload) {
                                this.showMessageAndClosePopup();
                            }
                        }
                    });

                //All columns grid level
                //this.ExportToExcel(null);
            }

        }
    }

    no() {
        this.props.closeModelDialog();
    }

    closePopUp() {
        $("#confirmPopUpModel").hide();
    }

    SelectedOption(value) {

        if (value == 'SelectedColumns') {
            optionId = 2;
        }
        else if (value == 'AllDefaultColumns') {
            optionId = 1;
        }
    }
    handleOptionChange(e) {
        this.setState({
            selectedOption: e.target.value
        });
    }

    onChangeIncludeRowGroup(e) {
        this.setState({
            isIncludeRowGroup: !this.state.isIncludeRowGroup,
            isIncludeColumnGroup: !self.state.isIncludeRowGroup
        });
    }
    onChangeIncludeColumnGroup(e) {

        self.setState({
            isIncludeColumnGroup: !self.state.isIncludeColumnGroup,
        });
    }
    Validation() {

        var isOption1 = $('#option1:checked').val() ? true : false;
        var isÒption2 = $('#option2:checked').val() ? true : false;

        if (!isOption1 && !isÒption2) {

            PopupWindow.showErrorMessage("Alert", "Please select the Export Mode");
            return false;
        }
        else {
            return true;
        }
    }

    myHeaderCallback(params) {

        if (params != undefined && params != null) {

            var fieldName = params.column.getColDef().field;
            var fieldHeaderName = params.column.getColDef().headerName;
            
            switch (fieldName) {
                
                case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM':
                case 'CreatedDTTM': case 'CreateDTTM': case 'StatusDate': case 'SubmittedOn': case 'EndDate': case 'scheduledCreatedDTTM':
                case 'StartDate': case 'LastPreTripDTTM': case 'PTRDateTime': case 'TTL': case 'GPSDTTM': case 'DeviceDataTime': case 'ExpirationTime':
                case 'EarliestDepartureDtm': case 'ArrivalDtm': case 'TWTime': case 'DLEventDTTM': case 'DoorEventDtm': case 'Door1EventDttm':
                case 'TripStart': case 'TripEnd': case "CTTime":
                    {
                        return Formatters.TimeZoneFormatter(fieldHeaderName);
                    }
                case 'SetPoint': case 'SupplyTemp1': case 'SupplyTemp2': case 'ReturnTemp1': case 'ReturnTemp2': case 'DeviceTemp': case 'InsideTemp':
                case 'AmbientTemp': case 'EvaporatorInletSensor': case 'EvaporatorOutletSensor': case 'CompressorSuctionTemp': case 'CompressorDischargeTemp': case 'TemperatureUnit':
                case 'CondenserTemperature': case 'USDA1Temp': case 'USDA2Temp': case 'USDA3Temp': case 'Cargo4Temp': case 'SensorSupplyTemp1': case 'SensorReturnTemp1':
                case 'CTTempLimit': case 'CTPostSetPoint': case 'CompressorDischargeTemp2': case 'EconomizerInTemp': case 'EconomizerOutTemp'://RCNG-1818

                    {
                        return Formatters.TemperatureHeaderFormatter(fieldHeaderName);
                    }
                case 'Door1BattPct': case 'BatteryPct': case 'ReeferBatteryPct':
                    return Formatters.DoorBattPctHeaderFormatter(fieldHeaderName);
                default:
                    return params.column.getColDef().headerName;
            }
        }
        //return params.column.getColDef().headerName.toUpperCase();
    }

    DoorBattPctHeaderCallback(params) {
        if (params != undefined && params != null) {

            var fieldName = params.column.getColDef().field;
            var fieldHeaderName = params.column.getColDef().headerName;

            switch (fieldName) {
                case 'Door1BattPct': case 'BatteryPct': case 'ReeferBatteryPct':
                    return Formatters.DoorBattPctHeaderFormatter(fieldHeaderName);
                default:
                    return params.column.getColDef().headerName;
            }
        }
        //return params.column.getColDef().headerName.toUpperCase();
    }
    getGroupDisplayValueName(params) {

        if (params != undefined && params != null) {

            var fieldName = params.node.field;
            var fieldValue = params.node.key;

            //var colDef = params.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
            //var columnDisplayName = colDef[0].colDef.headerName;
            var colDef = params.node.rowGroupColumn.colDef;//WI 26719
            var columnDisplayName = params.node.rowGroupColumn.colDef.headerName;//WI 26719

            if (fieldValue.toString().trim() == "-999" && (fieldName === 'BatteryVoltage' || fieldName === 'ExtBattVoltage' || fieldName === 'BattVoltage' || fieldName === 'DeviceBattery' || fieldName === 'TWState') || fieldName ==='DoorSensorBatteryVoltage')
                return "*No " + columnDisplayName;
            if (fieldValue.toString().trim() == "-1" && fieldName === 'Door1BattPct')
                return "*No " + columnDisplayName;
            if (fieldValue.toString().trim() == "-1" && (fieldName === 'BatteryPct' || fieldName === 'ReeferBatteryPct'))
                return "*No " + columnDisplayName;
            if (fieldValue.toString().trim() == "-999" && fieldName.toString().trim() != "TripWiseExpiration") //RCNG-169
                return "OOR";
            if (fieldValue == "-NA-" || fieldValue == "null" && fieldName!='TWState')
                return "*No " + columnDisplayName;

            if (fieldValue.toString().trim() == "-999" && self.validateFieldName(fieldName.toString().trim()))
                return "OOR";

            switch (fieldName) {
                case "PWR": case "DryPWR":
                    return Formatters.ChassisPWRFormatterGroupingForExcel(fieldValue);
                case "IgnitionOn":
                    return Formatters.GensetSwitchFormatterGroupingExcel(fieldValue);
                case "GensetRunning":
                    return Formatters.EngineSortingFormatterGroupingExcel(fieldValue);
                case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM':
                case 'CreatedDTTM': case 'CreateDTTM': case 'StatusDate': case 'SubmittedOn': case 'EndDate': case 'scheduledCreatedDTTM':
                case 'StartDate': case 'LastPreTripDTTM': case 'PTRDateTime': case 'TTL': case 'GPSDTTM': case 'DeviceDataTime': case 'ExpirationTime':
                case 'EarliestDepartureDtm': case 'ArrivalDtm': case 'TWTime': case 'DLEventDTTM': case 'DoorEventDtm': case 'Door1EventDTTM':
                case 'TripStart': case 'TripEnd': case "CTTime":
                        return Formatters.dateTypeFormatterGrouping(fieldValue);                    
                
                case 'CO2Setpoint': case 'CO2Reading': case 'O2Setpoint': case 'O2Reading': case 'EvaporatorTemp':
                case 'CompositeSuctionPressure': case 'CompressorSuctionTemp': case 'DischargePressure': case 'CompressorDischargeTemp':
                case 'CondenserTemperature': case 'CondenserFanOutPut': case 'LowSpeedEvaporatorFanOutPut': case 'HighSpeedEvaporatorFanOutPut':
                case 'HeaterOnTime': case 'HotGasValveOpening': case 'EconomizerValveOpening': case 'CompressorFrequency': case 'CompressorCurrent': case 'VentPositionSensorCMH':
                case 'TotalCurrentDraw': case 'LineVoltage1': case 'LineVoltage2': case 'LineVoltage3': case 'VFD': case 'CompressorCurrent':
                    {
                        return Formatters.sensorDataFormatterforExcel(fieldValue);
                    }
                
                case 'SetPoint': case 'SupplyTemp1': case 'SupplyTemp2': case 'ReturnTemp1': case 'ReturnTemp2':
                case 'AmbientTemp': case 'EvaporatorInletSensor': case 'EvaporatorOutletSensor': case 'CompressorSuctionTemp': case 'CompressorDischargeTemp':
                case 'CondenserTemperature': case 'USDA1Temp': case 'USDA2Temp': case 'USDA3Temp': case 'Cargo4Temp': case 'SensorSupplyTemp1': case 'SensorReturnTemp1':
                case 'CTTempLimit': case 'CTPostSetPoint': case 'CompressorDischargeTemp2': case 'EconomizerInTemp': case 'EconomizerOutTemp'://RCNG-1818
                    {
                        return Formatters.TemperatureFormatterforExcel(fieldValue);
                    }                
                case "DeviceTemp":
                    {
                        var DeviceType;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                        }
                        return Formatters.DevcieTempGrouping(fieldValue, DeviceType);
                    }
                case "InsideTemp":
                    {
                        var DeviceType; 
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                        }
                        return Formatters.InsideTempGrouping(fieldValue, DeviceType );
                    }
                case 'XAxis': case 'YAxis': case 'ZAxis':
                    {
                        return Formatters.GravityVectorValueFormatterforGroup(fieldValue);
                    }
                case 'Illumination':
                    {
                        return Formatters.LuxValueFormatterforGroup(fieldValue);
                    }
                case 'TemperatureUnit':
                    return Formatters.TemperatureFormatterForBookingforExcel(fieldValue);
                case 'IsInsideGeofence': case 'IsActive': case 'HasOilPressureSwitch':
                    {
                        return Formatters.YesNoConverterforExcel(fieldValue);
                    }
                case "RunState":
                    return Formatters.RunStateFormatterGroupingForExcel(fieldValue);
                case 'AssetState':
                    return Formatters.AssetStateFormatterGroupingForExcel(fieldValue);//Asset State changes
                case "MASeverityLevel":
                    return Formatters.statusIndicatorforALMforGrouping(fieldValue);
                case "DevicePowerSourceCd":
                    return Formatters.PowerStateFormatterGroupingForExcel(fieldValue);//done
                case "CCSeverityLevel":
                    return Formatters.CargoCareFormatterGroupingForExcel(fieldValue);
                case "TripStatusCdAndDFlag":
                    {

                        return Formatters.TripStatusFormatterGroupingForExcel(fieldValue);
                    }
                case 'AlarmsList':
                    return Formatters.AlarmListFormatterforExcel(fieldValue);
                case 'GPSHDOP':
                    return Formatters.GPSHDOPTypeFormatterForExcel(params.node.data.GPSHDOP, params.node.data.GPSLockState);
                case 'GPSSatelliteCount':
                    return Formatters.GPSSatCountTypeFormatterForExcel(params.node.data.GPSSatelliteCount, params.node.data.GPSLockState);
                case 'DryGPSHDOP':
                    return Formatters.GPSHDOPTypeFormatterForExcel(params.node.data.DryGPSHDOP, params.node.data.GPSLockState);
                case 'PositionAccuracy':
                    return Formatters.GPSAcctypeFormatterForExcel(fieldValue);
                case 'DryGPSSatelliteCount':
                    return Formatters.GPSSatCountTypeFormatterForExcel(params.node.data.DryGPSSatelliteCount, params.node.data.GPSLockState);
                case 'ChassisGPSHDOP':
                    return Formatters.GPSHDOPTypeFormatterForExcel(params.node.data.ChassisGPSHDOP, params.node.data.GPSLockState);
                case 'ChassisGPSSatelliteCount':
                    return Formatters.GPSSatCountTypeFormatterForExcel(params.node.data.ChassisGPSSatelliteCount, params.node.data.GPSLockState);
                case 'ExtBattVoltage': case 'BattVoltage': case 'DeviceBattery':
                    {
                        return (fieldValue == "" || fieldValue == null || fieldValue === '-NA-' || fieldValue === '-999') ? '-NA-' : Formatters.BattVoltageSortingGrouping(fieldValue);
                    }
                case 'Door1BattPct': case 'BatteryPct':
                    {                        
                        return (fieldValue == "" || fieldValue == null || fieldValue === '-NA-' || fieldValue === '-1') ? '-NA-' : Formatters.DoorBattPctSortingGrouping(fieldValue);
                    }
                case 'PossibleDamage':
                    {
                        return Formatters.PossibleDamageForExcel(fieldValue);
                    }
                case 'ReeferBatteryPct':
                    {
                        var DeviceType;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                        }
                        return Formatters.ReeferBattPctSortingGrouping(fieldValue, DeviceType);
                    }
                case 'DeviceConfig': case 'GuestReeferMode':
                    {

                        return Formatters.GuestReeferModeFormatterForExcel(fieldValue);
                    }
                case 'DrySpeed': case 'ChassisSpeed':
                    {
                        return Formatters.SpeedConverterforExcel(fieldValue);
                    }

                case 'RCDPOWERSOURCECD': if (params.value != undefined && params.value != null) return Formatters.rcdPowerSourceFormatterforExcel(fieldValue);

                case "CustomerName":
                    return fieldValue == JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "-NA-" : fieldValue;
                case "ReeferOEMTypeCd": case "OEMTypeCD"://WI-26787
                    return Formatters.OEMTypeFormatterGrouping(fieldValue);
                case "RSSI":
                    return Formatters.RSSIFormatterGroupingForExcel(fieldValue);
                case "DeviceConfig":
                    return Formatters.GuestReeferModeGrouping(fieldValue);
                case "PTIState":
                    return (fieldValue == "" || fieldValue == null) ? '-NA-' : fieldValue;
                case "BatteryStatus": //case"PWR":
                    return Formatters.ChassisBatteryStatusFormatterGroupingExcel(fieldValue);
                case "ChassisBatteryStatus":
                    return Formatters.ChassisBatteryStatusFormatterGroupingExcel(fieldValue);
                case "DoorOpen"://RCNG-1106
                    return reeferFormatters.DoorFormatterGrouping(fieldValue);
                case "Door1Open":
                    return Formatters.Door1FormatterGrouping(fieldValue);  //RCNG-2377
                case "TWState":
                    {
                        var ReeferOemTypeCd; var DimiResultActuator; var DimiResultAlarm; var DimiResultOOR; var DimiMode = null; var DimiResultTerm = null;var DimiResultValidity = null
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            ReeferOemTypeCd = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].ReeferOemTypeCd;
                            DimiResultActuator = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultActuator;
                            DimiResultAlarm = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultAlarm;
                            DimiResultOOR = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultOOR;
                            DimiMode = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiMode;
                            DimiResultTerm = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultTerm;//Added DimiResultTerm
                            DimiResultValidity = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultValidity;
                        }
                        return Formatters.TripWiseGroupingForExcel(fieldValue, ReeferOemTypeCd, DimiResultActuator, DimiResultAlarm, DimiResultOOR, DimiResultTerm, DimiMode,DimiResultValidity);
                    }
                case "GPSCoords":
                    return Formatters.GPSCoordsFormatterForExcel(fieldValue, params);
                case "Sensor1Value_GT1200": case "Sensor2Value_GT1200": case 'Sensor3Value_GT1200': case 'Sensor4Value_GT1200': case "Sensor5Value_GT1200": case "Sensor6Value_GT1200": case 'Sensor7Value_GT1200': case 'Sensor8Value_GT1200':
                case "Sensor1Value_GT1020": case "Sensor2Value_GT1020": case 'Sensor3Value_GT1020': case 'Sensor4Value_GT1020': case "Sensor5Value_GT1020": case "Sensor6Value_GT1020": case 'Sensor7Value_GT1020': case 'Sensor8Value_GT1020':
                case "Sensor1Value_ST9100": case "Sensor2Value_ST9100": case 'Sensor3Value_ST9100': case 'Sensor4Value_ST9100': case "Sensor5Value_ST9100": case "Sensor6Value_ST9100": case 'Sensor7Value_ST9100': case 'Sensor8Value_ST9100':
                case "Sensor1Value_GT1030": case "Sensor2Value_GT1030": case 'Sensor3Value_GT1030': case 'Sensor4Value_GT1030': case "Sensor5Value_GT1030": case "Sensor6Value_GT1030": case 'Sensor7Value_GT1030': case 'Sensor8Value_GT1030':
                    return Formatters.SensorGrouping(fieldName.toString().trim(), fieldValue, self.state.sensorData, colDef);
                case 'HumiditySetpoint':
                    {
                        var HumiditySetpointStatus;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            HumiditySetpointStatus = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HumiditySetpointStatus;
                        }                        
                        return Formatters.HumiditySetpointForExcel(fieldValue, HumiditySetpointStatus);
                    }
                case 'EverFRESH':
                    return Formatters.EverFreshFormatterGrouping(fieldValue);
                case 'DimiStartAfter':
                    return Formatters.OEMPTITypeFormatter(fieldValue);
                default:
                    return fieldValue;

            }


        }
    }


    validateFieldName(fieldName: any) {
        var IsValid = true;
        switch (fieldName) {
            case "Sensor1Value_GT1200": case "Sensor2Value_GT1200": case 'Sensor3Value_GT1200': case 'Sensor4Value_GT1200': case "Sensor5Value_GT1200": case "Sensor6Value_GT1200": case 'Sensor7Value_GT1200': case 'Sensor8Value_GT1200':
            case "Sensor1Value_GT1020": case "Sensor2Value_GT1020": case 'Sensor3Value_GT1020': case 'Sensor4Value_GT1020': case "Sensor5Value_GT1020": case "Sensor6Value_GT1020": case 'Sensor7Value_GT1020': case 'Sensor8Value_GT1020':
            case "Sensor1Value_ST9100": case "Sensor2Value_ST9100": case 'Sensor3Value_ST9100': case 'Sensor4Value_ST9100': case "Sensor5Value_ST9100": case "Sensor6Value_ST9100": case 'Sensor7Value_ST9100': case 'Sensor8Value_ST9100':
            case "Sensor1Value_GT1030": case "Sensor2Value_GT1030": case 'Sensor3Value_GT1030': case 'Sensor4Value_GT1030': case "Sensor5Value_GT1030": case "Sensor6Value_GT1030": case 'Sensor7Value_GT1030': case 'Sensor8Value_GT1030':
                { IsValid = false; }
                break;
        }
        return IsValid;
    }

    myRowGroupCallback(params) {

        var indent = '--';
        var node = params.node;
        //var label = node.key.toUpperCase();

        var label = self.getGroupDisplayValueName(params);
        if (!node.parent.parent) {
            return label; // top level node, parent is root node
        }
        label = '> ' + label;
        // indent once per level in the row group hierarchy
        while (node.parent.parent) {
            label = indent + label;
            node = node.parent;
        }
        return label;



    }

    myCellCallback(params) {
        
        var returnValue;
        var returnValue;
        var serverSideEnabled = JSON.parse(sessionStorage.getItem('SSRM'));
        var isServerSideEnabled = self.props.IsServerSideEnabled;
        if (serverSideEnabled) {
            if (params.node.group && ProcessfirstCellOnlyRowIndex != params.node.rowGroupIndex) {
                ProcessfirstCellOnlyRowIndex = params.node.rowGroupIndex
                if (params.node.key != null && params.node.key != undefined)
                    return self.myRowGroupCallback(params);
            }

            if (params.node.group && params.column.colId === "0") {
                return self.myRowGroupCallback(params);
            }

            if (!params.node.group) {
                switch (params.column.colId) {

                    case 'RCDID': case 'RCDId': case 'TowerBaseStationID': case 'ICCID': case 'MSISDN': case 'SIM_IMSI': case 'RcdID': case 'Value1':
                    case 'Value3': case 'Value4':
                        {
                            if (params.value == undefined || params.value == "-NA-")
                                returnValue = "-NA-";
                            else
                                returnValue = params.value;
                        }
                        break;
                    case 'CO2Setpoint': case 'CO2Reading': case 'O2Setpoint': case 'O2Reading': case 'EvaporatorTemp':
                    case 'CompressorSuctionTemp': case 'CompressorDischargeTemp':
                    case 'CondenserTemperature': case 'CondenserFanOutPut': case 'LowSpeedEvaporatorFanOutPut': case 'HighSpeedEvaporatorFanOutPut':
                    case 'HeaterOnTime': case 'HotGasValveOpening': case 'EconomizerValveOpening': case 'CompressorFrequency': case 'CompressorCurrent': case 'VentPositionSensorCMH':
                    case 'TotalCurrentDraw': case 'VFD': 
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.sensorDataFormatterforExcel(params.value);
                            else
                                returnValue = "-NA-";
                        }
                        break;
                    case 'LineFrequency' :
                    {
                        var OEMTypeCd;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node != undefined
                            && params.node != null) {
                            OEMTypeCd = params.node.data.ReeferOEMTypeCd;
                        }
                        else {
                            OEMTypeCd = "";
                        }
                        if(OEMTypeCd != null && OEMTypeCd != "") {
                            if(OEMTypeCd.toString().toUpperCase().trim() == "D" && (params.node.data.ControllerTypeCd == 27 || params.node.data.ControllerTypeCd == 28 || params.node.data.ControllerTypeCd == 32))
                               if (params.value != undefined && params.value != null && params.value != '-NA-')
                                 returnValue = Formatters.lineFrequencyFormatterforExcel(params.node.data.LineFrequencyQualifier, params.value);
                                else
                                    returnValue = "-NA-";
                            else {   
                                if (params.value != undefined && params.value != null)
                                    returnValue = Formatters.sensorDataFormatterforExcel(params.value);
                                else
                                    returnValue = "-NA-";
                            }  
                        }
                        else {
                            if (params.value != undefined && params.value != null)
                                    returnValue = Formatters.sensorDataFormatterforExcel(params.value);
                                else
                                    returnValue = "-NA-";
                        }
                    }
                    break;
                    case 'CompositeSuctionPressure': case 'DischargePressure': case 'LineVoltage1': case 'LineVoltage2': case 'LineVoltage3': case 'CompressorCurrent':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.sensorDataFormatterforExcelTwoDecimal(params.value);
                            else
                                returnValue = "-NA-";
                        }
                        break;
                    case 'SetPoint': case 'SupplyTemp1': case 'SupplyTemp2': case 'ReturnTemp1': case 'ReturnTemp2':
                    case 'AmbientTemp': case 'EvaporatorInletSensor': case 'EvaporatorOutletSensor': case 'CompressorSuctionTemp': case 'CompressorDischargeTemp':
                    case 'CondenserTemperature': case 'USDA1Temp': case 'USDA2Temp': case 'USDA3Temp': case 'Cargo4Temp': case 'SensorSupplyTemp1': case 'SensorReturnTemp1':
                    case 'CTTempLimit': case 'CTPostSetPoint': case 'CompressorDischargeTemp2': case 'EconomizerInTemp': case 'EconomizerOutTemp'://RCNG-1818
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.TemperatureFormatterforExcel(params.value);
                            else
                                returnValue = "-NA-";
                        }
                        break
                    case 'DeviceTemp': case 'InsideTemp':
                        {
                            if (params != undefined && params != null)
                                returnValue = Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                            else
                                returnValue = "-NA-";
                        }
                        break
                    case 'XAxis': case 'YAxis': case 'ZAxis':
                        {
                            return Formatters.GravityVectorValueFormatter(params);
                        }
                        break
                    case 'Illumination':
                        {
                            return Formatters.LuxValueFormatter(params);
                        }
                    case 'TemperatureUnit':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.TemperatureFormatterForBookingforExcel(params.value);
                            else
                                returnValue = "-NA-";
                        }
                        break
                    case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM':
                    case 'CreatedDTTM': case 'CreateDTTM': case 'StatusDate': case 'SubmittedOn': case 'EndDate': case 'scheduledCreatedDTTM':
                    case 'StartDate': case 'LastPreTripDTTM': case 'PTRDateTime': case 'TTL': case 'GPSDTTM': case 'DeviceDataTime': case 'ExpirationTime':
                    case 'EarliestDepartureDtm': case 'ArrivalDtm': case 'TWTime': case 'DoorEventDtm': case 'Door1EventDttm':
                    case 'TripStart': case 'TripEnd': case "CTTime":
                        {
                            //if (params.value != undefined && params.value != null)
                            returnValue = Formatters.dateTypeFormatterforExcel(params.value);
                        }
                        break
                    case 'Name': case 'Description': case 'RCDBootloaderVersion': case 'PTResult': case 'VesselCd': case 'DeviceType':
                    case 'GeofenceTag': case 'VesselName': case 'Origin': case 'Handler': case 'TripStatusCdAndDFlag':
                    case 'UserName': case 'TagName': case 'Created': case 'DeploymentName': case 'CreatedBy': case 'ModifiedBy': case 'SubmittedBy':
                    case 'FullName': case 'Zip': case 'CCSeverityLevelGenset': case 'OEMModel': 
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.stringTypeFormatterChildFormsNew(params.value);
                            else
                                returnValue = "-NA-";
                        }
                        break;
                    case 'DimiStartAfter':
                        returnValue = Formatters.OEMPTITypeFormatter(params.value);
                        break;
                    case 'CommentExists': case 'CommentExistsGenset': case 'CommentExistsDC': case 'CommentExistsChassis':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.CommentExistsforExcel(params.value);
                        }
                        break;
                    case 'PossibleDamage':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.PossibleDamageForExcel(params.value);
                        }
                        break;
                    case 'IsInsideGeofence': case 'IsActive': case 'HasOilPressureSwitch':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.YesNoConverterforExcel(params.value);
                        }
                        break
                    case 'ReeferOEMTypeCd': case 'ÓEMTypeCD':
                        {
                            //if (params.value != undefined && params.value != null)
                            returnValue = Formatters.GetOEMTypeDescription(params.value);
                        }
                        break;
                    case 'GPSHDOP':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSHDOPTypeFormatterForExcel(params.node.data.GPSHDOP, params.node.data.GPSLockState);
                        }
                        break;
                    case 'GPSSatelliteCount':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSSatCountTypeFormatterForExcel(params.node.data.GPSSatelliteCount, params.node.data.GPSLockState);
                        }
                        break;
                    case 'DryGPSHDOP':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSHDOPTypeFormatterForExcel(params.node.data.DryGPSHDOP, params.node.data.GPSLockState);
                        }
                        break;
                    case 'PositionAccuracy':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSAcctypeFormatterForExcel(params.node.data.PositionAccuracy);
                        }
                        break;
                    case 'DryGPSSatelliteCount':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSSatCountTypeFormatterForExcel(params.node.data.DryGPSSatelliteCount, params.node.data.GPSLockState);
                        }
                        break;
                    case 'ChassisGPSHDOP':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSHDOPTypeFormatterForExcel(params.node.data.ChassisGPSHDOP, params.node.data.GPSLockState);
                        }
                        break;
                    case 'ChassisGPSSatelliteCount':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSSatCountTypeFormatterForExcel(params.node.data.ChassisGPSSatelliteCount, params.node.data.GPSLockState);
                        }
                        break;
                    case 'ExtBattVoltage': case 'BattVoltage': case 'DeviceBattery': case 'BatteryVoltage': case 'DoorSensorBatteryVoltage':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.BattVoltageFormatterforExcel(params.value);
                        }
                        break;
                    case 'Door1BattPct':
                        {
                            returnValue = Formatters.DoorBattPctFormatterforExcel(params.node.data.Door1BattPct); //door1BattPct);
                        }
                        break;
                    case 'BatteryPct':
                        {
                            returnValue = Formatters.DoorBattPctFormatterforExcel(params.node.data.BatteryPct); 
                        }
                        break;
                    case 'ReeferBatteryPct':
                        {
                            returnValue = Formatters.ReeferBattPctFormatterforExcel(params.node.data.ReeferBatteryPct, params.node.data.DeviceType);
                        }
                        break;
                    case 'DeviceConfig': case 'GuestReeferMode':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GuestReeferModeFormatterForExcel(params.value);
                        }
                        break;
                    case 'DrySpeed': case 'ChassisSpeed': case 'Speed':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.SpeedConverterforExcel(params.value);
                        }
                        break;
                    case 'RCDPOWERSOURCECD': if (params.value != undefined && params.value != null) returnValue = Formatters.rcdPowerSourceFormatterforExcel(params.value);
                        break;
                    case 'RunState': if (params.value != undefined && params.value != null) returnValue = Formatters.RunStateFormatterGroupingForExcel(params.value);
                        break;
                    case 'AssetState': if (params.value != undefined && params.value != null) returnValue = Formatters.AssetStateFormatterGroupingForExcel(params.value);//Asset State changes
                        break;
                    case 'R_HighestSeverityLevel': {
                        if (params.value != undefined && params.value != null)
                            returnValue = Formatters.statusIndicatorforALMforExcel(params.value);
                    }
                        break;
                    case 'MASeverityLevel':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.statusIndicatorforALMforExcel(params.node.data.MASeverityLevel);
                        }
                        break;
                    case 'AlertSeverityID': if (params.value != undefined && params.value != null) returnValue = Formatters.statusIndicatorforALRforExcel(params.value); break;
                    case 'IsOnVessel': if (params.value != undefined && params.value != null) returnValue = Formatters.isOnVesselFormatterChildForms(params.value); break;
                    case 'GPSLastLock': if (params.value != undefined && params.value != null) returnValue = Formatters.secondsToTimeConverterForExcel(params.node.data.GPSLastLock); break;
                    case 'AlarmsList': if (params.value != undefined && params.value != null) returnValue = Formatters.AlarmListFormatterforExcel(params.value); break;
                    case 'TemperatureUnit': if (params.value != undefined && params.value != null) returnValue = Formatters.TemperatureFormatterForBookingforExcel(params.value); break;
                    case 'ThreePhaseCurrent': if (params.value != undefined && params.value != null) returnValue = Formatters.Current3PhaseFormatterforExcel(params.value); break;
                    case 'FilerepositoryActionCD': if (params.value != undefined && params.value != null) returnValue = Formatters.GetFileRepositoryActionDesc(params.value); break;
                    case 'GeofenceCategoryCd': if (params.value != undefined && params.value != null) returnValue = Formatters.fenceTypeFormatterForExcel(params.value); break;
                    case 'IgnitionOn': if (params.value != undefined && params.value != null) returnValue = Formatters.gensetSwitchFormatterForExcel(params.value); break;
                    case 'BatteryStatus': if (params.value != undefined && params.value != null) returnValue = Formatters.ChassisBatteryStatusFormatterForExcel(params.node.data.BatteryStatus); break;
                    case 'BreakSignal': if (params.value != undefined && params.value != null) returnValue = Formatters.BrakeSignalFormatterForExcel(params.value); break;
                    case 'TripWiseExpiration':
                    {
                    if (params.value != undefined && params.value != null) returnValue = Formatters.TripWiseExpirationFormatterforExcel(params.value); 
                    }
                        break;   
                    case 'DimiRemainTerm':case 'DimiTerm': if (params.value != undefined && params.value != null) returnValue = Formatters.DimiRemainTermFormatterforExcel(params.value); break;
                    case 'AirPumpRunHours': if (params.value != undefined && params.value != null) returnValue = Formatters.AirPumpRunHoursFormatterforExcel(params.value); break;
                    case 'CompressorRunHours': if (params.value != undefined && params.value != null) returnValue = Formatters.CompressorRunHoursFormatterforExcel(params.value); break;                        
                    case 'CARunHours': if (params.value != undefined && params.value != null) returnValue = Formatters.CARunHoursFormatterforExcel(params.value); break;                        
                    case 'PowerMeter': if (params.value != undefined && params.value != null) returnValue = Formatters.PowerMeterFormatterforExcel(params.value); break;                        
                    case 'CASoftwareRevision': if (params.value != undefined && params.value != null) returnValue = Formatters.CASWVerFormatterforExcel(params.value); break;                        
                    case 'CTDuration': if (params.value != undefined && params.value != null) returnValue = Formatters.CTDurationorRemainingTimeFormatterforExcel(params.value); break;//RCNG-1818
                    case 'CTRemainingTime': if (params.value != undefined && params.value != null) returnValue = Formatters.CTDurationorRemainingTimeFormatterforExcel(params.value); break;//RCNG-1818
                    case 'CustomerName': if (params.value != undefined && params.value != null) returnValue = Formatters.stringTypeFormatterFor3PExcel(params.value); break;
                    case 'TWState': if (params.value != undefined && params.value != null) returnValue = Formatters.tripWiseFormatterForExcel(params); break;
                    //case 'PWR': if (params.value != undefined && params.value != null) returnValue = Formatters.pwrStateFormatterChassisforExcel(params.node.data.PWR); break;
                    case 'PWR': case 'DryPWR': if (params.value != undefined && params.value != null) returnValue = Formatters.pwrStateFormatterChassisforExcel(params.value); break;
                    case 'Loaded': if (params.value != undefined && params.value != null) returnValue = Formatters.LoadedFormatterForExcel(params.value); break;
                    case "RSSI": if (params.value != undefined && params.value != null) returnValue = params.node.data.RSSI; break;
                    case 'FractionDisplay': {

                        if (params.value != undefined && params.value != null) {

                            var FuelLevelQualifier;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                FuelLevelQualifier = params.node.FuelLevelQualifier;
                            }
                            else {
                                FuelLevelQualifier = "";
                            }

                            var HasFuelSensor;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                HasFuelSensor = params.node.HasFuelSensor;
                            }
                            else {
                                HasFuelSensor = "";
                            }

                        }


                        var isFuelinfo = {
                            FuelLevelQualifier: FuelLevelQualifier,
                            FractionDisplay: params.value,
                            HasFuelSensor: HasFuelSensor
                        };
                        if (FuelLevelQualifier != undefined && FuelLevelQualifier != null && HasFuelSensor != undefined && HasFuelSensor != null)
                            returnValue = Formatters.FillLevelTraceFormatterforExcel(isFuelinfo);
                    }
                    case 'HasFuelSensor': {
                        if (params.value != undefined && params.value != null) {
                            var FuelLevelQualifier;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                FuelLevelQualifier = params.node.FuelLevelQualifier;
                            }
                            else {
                                FuelLevelQualifier = "";
                            }

                            var FuelLevelQualifierDesc;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                FuelLevelQualifierDesc = params.node.FuelLevelQualifierDesc;
                            }
                            else {
                                FuelLevelQualifierDesc = "";
                            }

                            var isFuelinfo2 = {
                                HasFuelSensor: params.value,
                                FuelLevelQualifier: FuelLevelQualifier,
                                FuelLevelQualifierDesc: FuelLevelQualifierDesc
                            };

                            if (FuelLevelQualifier != undefined && FuelLevelQualifier != null)
                                returnValue = Formatters.FuelSensorTraceFormatterforExcel(isFuelinfo2);
                        }
                        break;
                    }
                    case 'ManufacturedDate':
                        {
                            if (params.value != undefined && params.value != null) returnValue = Formatters.YearFromdateTypeFormatterForExcelNew(params.value);
                        }
                        break;
                    case 'AssetType': returnValue = Formatters.AssetTypeFormatterForExcel(params.value); break;
                    case 'PreTrip': {
                        if (params.value != undefined && params.value != null) {
                            if (this.state.formName == "PreTrip")
                                returnValue = Formatters.PTIStateforExcel(params.value);
                            else
                                returnValue = Formatters.stringTypeFormatterChildForms(params.value);
                        }
                    }
                        break;
                    case 'CCSeverityLevel':
                        {
                            if (params.value != undefined && params.value != null) {

                                var IsCargoCare;
                                //IsCargocare = self.getOtherColumnCellValue(params, "IsCargocare");
                                //if (params.node.rowIndex != undefined && params.node.rowIndex != null) {

                                //}
                                if (params.node != undefined && params.node != null && params.node.data != undefined && params.node.data != null)
                                    IsCargoCare = params.node.data.IsCargoCare; //RCNG-241 Renamed Normal to Assigned
                                else {
                                    IsCargoCare = false;
                                }
                                if (IsCargoCare != undefined && IsCargoCare != null)
                                    returnValue = Formatters.CargoCareFormatterforExcel({ isCargocare: IsCargoCare, CCSeverityLevel: params.value });
                            }
                        }
                        break;
                    case 'DoorOpen': //RCNG-1106
                        {
                            if (params.value != undefined && params.value != null) {
                                //var HasDoorSensor;
                                //if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                //    && params.node != undefined
                                //    && params.node != null) {
                                //    HasDoorSensor = params.node.HasDoorSensor;
                                //}
                                //else {
                                //    HasDoorSensor = false;
                                //}
                                //if (HasDoorSensor != undefined && HasDoorSensor != null)
                                //   returnValue = Formatters.DoorFormatterExcel({ Door1Open: params.value, HasDoorSensor: HasDoorSensor });

                                returnValue = reeferFormatters.DoorFormatterExcel(params.value);
                            }
                        }
                        break;
                    case 'Door1Open':
                        {
                            if (params.value != undefined && params.value != null) {
                                returnValue = Formatters.Door1FormatterExcel(params.value);
                            }
                            else
                                returnValue = '-NA-';
                        }
                        break;
                    case 'Humidity':
                        {
                            if (params.value != undefined && params.value != null) {
                                var HumiditySetpointStatus;
                                //HumiditySetpointStatus1 = this.getOtherColumnCellValue(params, "HumiditySetpointStatus");
                                if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                    && params.node != undefined
                                    && params.node != null) {
                                    HumiditySetpointStatus = params.node.HumiditySetpointStatus;
                                }
                                else {
                                    HumiditySetpointStatus = "";
                                }

                                if (HumiditySetpointStatus != undefined && HumiditySetpointStatus != null)
                                    returnValue = Formatters.HumiditySettingFormatterforExcel({ Humidity: params.value, HumiditySetpointStatus: HumiditySetpointStatus });
                                else
                                    returnValue = '-NA-'; // WI 26545
                            }
                        }
                        break;
                    case 'ControlledAtmosphereMode': {
                        if (params.value != undefined && params.value != null) {
                            var ReeferOEMTypeCd;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                ReeferOEMTypeCd = params.node.ReeferOEMTypeCd;
                            }
                            else {
                                ReeferOEMTypeCd = "";
                            }

                            if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null)
                                returnValue = Formatters.ControlledAtmosphereModeforExcel({ ReeferOEMTypeCd: ReeferOEMTypeCd, ControlledAtmosphereMode: params.value });
                        }
                    }
                        break;
                    case 'SuctionModulationValveOpening': {
                        if (params.value != undefined && params.value != null) {
                            var ReeferOEMTypeCd;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                ReeferOEMTypeCd = params.node.ReeferOEMTypeCd;
                            }
                            else {
                                ReeferOEMTypeCd = "";
                            }

                            var SuctionModulationValveOpeningQualifier;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                SuctionModulationValveOpeningQualifier = params.node.SuctionModulationValveOpeningQualifier;
                            }
                            else {
                                SuctionModulationValveOpeningQualifier = "";
                            }

                            var SuctionModulationValveOpeningData = {
                                ReeferOEMTypeCd: ReeferOEMTypeCd,
                                SuctionModulationValveOpeningQualifier: SuctionModulationValveOpeningQualifier,
                                SuctionModulationValveOpening: params.value
                            };

                            if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null && SuctionModulationValveOpeningQualifier != undefined && SuctionModulationValveOpeningQualifier != null)
                                returnValue = Formatters.sensorDataOpenSucFormatterForExcel(SuctionModulationValveOpeningData);
                        }
                    }
                        break;
                    case 'CondenserPressure': {
                        if (params.value != undefined && params.value != null) {
                            var ReeferOEMTypeCd;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                ReeferOEMTypeCd = params.node.ReeferOEMTypeCd;
                            }
                            else {
                                ReeferOEMTypeCd = "";
                            }

                            if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null)
                                returnValue = Formatters.sensorDataPCondFormatterExcel({ ReeferOEMTypeCd: ReeferOEMTypeCd, CondenserPressure: params.value });
                        }
                    }
                        break;
                    case 'EvaporatorExpansionValveOpening': {
                        if (params.value != undefined && params.value != null) {
                            var ReeferOEMTypeCd;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                ReeferOEMTypeCd = params.node.ReeferOEMTypeCd;
                            }
                            else {
                                ReeferOEMTypeCd = "";
                            }
                            var EEVData = {
                                ReeferOEMTypeCd: ReeferOEMTypeCd,
                                EvaporatorExpansionValveOpening: params.value
                            };
                            if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null)
                                returnValue = Formatters.sensorDataOpenExpFormatterExcel(EEVData);
                        }
                    }
                        break;
                    case 'GensetRunning': {
                        if (params.value != undefined && params.value != null) {
                            // Start WI-26787
                            //var HasOilPressureSwitch;
                            //if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            //    && params.node != undefined
                            //    && params.node != null) {
                            //    HasOilPressureSwitch = params.node.HasOilPressureSwitch;
                            //}
                            //else {
                            //    HasOilPressureSwitch = false;
                            //}

                            //if (HasOilPressureSwitch != undefined && HasOilPressureSwitch != null)
                            var isGensetRunning = {
                                GensetRunning: params.node.data.GensetRunning,
                                HasOilPressureSwitch: params.node.data.HasOilPressureSwitch,
                                OEMTypeCD: params.node.data.OEMTypeCD
                            };
                            returnValue = Formatters.EngFormatterforExcel(isGensetRunning);
                            // End WI-26787
                        }
                    }
                        break;
                    case 'FuelLevel': case 'FractionDisplay': {
                        if (params.value != undefined && params.value != null) {
                            var FuelLevelQualifier;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                FuelLevelQualifier = params.node.FuelLevelQualifier;
                            }
                            else {
                                FuelLevelQualifier = "";
                            }
                            var FuelLevelQualifierDesc;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                FuelLevelQualifierDesc = params.node.FuelLevelQualifierDesc;
                            }
                            else {
                                FuelLevelQualifierDesc = "";
                            }
                            var FractionDisplay;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                FractionDisplay = params.node.FractionDisplay;
                            }
                            else {
                                FractionDisplay = false;
                            }
                            var HasFuelSensor;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                HasFuelSensor = params.node.HasFuelSensor;
                            }
                            else {
                                HasFuelSensor = false;
                            }

                            var isFuelinfo3 = {
                                FuelLevel: params.value,
                                FuelLevelQualifier: FuelLevelQualifier,
                                FuelLevelQualifierDesc: FuelLevelQualifierDesc,
                                FractionDisplay: FractionDisplay,
                                HasFuelSensor: HasFuelSensor
                            };
                            if (FuelLevelQualifier != undefined && FuelLevelQualifier != null &&
                                FuelLevelQualifierDesc != undefined && FuelLevelQualifierDesc != null &&
                                FractionDisplay != undefined && FractionDisplay != null &&
                                HasFuelSensor != undefined && HasFuelSensor != null)
                                returnValue = Formatters.FillLevelGalTraceFormatterforExcel(isFuelinfo3);
                        }
                    }
                        break;
                    case 'DevicePowerSourceCd': {
                        if (params.value != undefined && params.value != null) {
                            //var DeviceConfig;
                            //if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            //    && params.node != undefined
                            //    && params.node != null) {
                            //    DeviceConfig = params.node.DeviceConfig;
                            //}
                            //else {
                            //    DeviceConfig = false;
                            //}

                            //var DeviceType;
                            //if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            //    && params.node != undefined
                            //    && params.node != null) {
                            //    DeviceType = params.node.DeviceType;
                            //}
                            //else {
                            //    DeviceType = "";
                            //}

                            var ispwrStateFormatter = {
                                DeviceType: params.node.data.DeviceConfig,
                                DevicePowerSourceCd: params.node.data.DevicePowerSourceCd,
                                DeviceTypeCd: params.node.data.DeviceType
                            };
                            
                            //if (DeviceType != undefined && DeviceType != null && DeviceConfig != undefined && DeviceConfig != null)
                            returnValue = Formatters.pwrStateFormatterforExcel(ispwrStateFormatter);
                        }
                    }
                        break;
                    case 'Door1OpenChassis': {
                        if (params.value != undefined && params.value != null) {
                            var HasDoorSensor;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node != undefined
                                && params.node != null) {
                                HasDoorSensor = params.node.HasDoorSensor;
                            }
                            else {
                                HasDoorSensor = false;
                            }

                            var door1ChassisStateFormatter = {
                                HasDoorSensor: HasDoorSensor,
                                Door1OpenChassis: params.value
                            };

                            if (HasDoorSensor != undefined && HasDoorSensor != null)
                                returnValue = Formatters.DoorFormatterChassisforExcel(door1ChassisStateFormatter);
                        }
                    }
                        break;
                    case "GPSCoords":
                        return Formatters.GPSCoordsFormatterGroupingForExcel(params);
                    case "Sensor1Value_GT1200": case "Sensor2Value_GT1200": case 'Sensor3Value_GT1200': case 'Sensor4Value_GT1200': case "Sensor5Value_GT1200": case "Sensor6Value_GT1200": case 'Sensor7Value_GT1200': case 'Sensor8Value_GT1200':
                    case "Sensor1Value_GT1020": case "Sensor2Value_GT1020": case 'Sensor3Value_GT1020': case 'Sensor4Value_GT1020': case "Sensor5Value_GT1020": case "Sensor6Value_GT1020": case 'Sensor7Value_GT1020': case 'Sensor8Value_GT1020':
                    case "Sensor1Value_ST9100": case "Sensor2Value_ST9100": case 'Sensor3Value_ST9100': case 'Sensor4Value_ST9100': case "Sensor5Value_ST9100": case "Sensor6Value_ST9100": case 'Sensor7Value_ST9100': case 'Sensor8Value_ST9100':
                    case "Sensor1Value_GT1030": case "Sensor2Value_GT1030": case 'Sensor3Value_GT1030': case 'Sensor4Value_GT1030': case "Sensor5Value_GT1030": case "Sensor6Value_GT1030": case 'Sensor7Value_GT1030': case 'Sensor8Value_GT1030':
                        {
                            if (params.value != undefined && params.value != null) {
                                if (self.state.sensorData != undefined && self.state.sensorData != null) {
                                    var columnFieldName = params.column.colId;
                                    var deviceType = params.node.data.DeviceType;
                                    var name = columnFieldName.split("_");
                                    var fieldName = name[0];
                                    var value = params.node.data[name[0]];

                                    if (value != null && value != undefined) {
                                        var sensorcolumn = self.state.sensorData.filter(x => x.FieldName == fieldName && x.DeviceTypeCd.trim() == deviceType.trim());
                                        if (sensorcolumn[0] != undefined && sensorcolumn[0] != null) {
                                            if (sensorcolumn[0].SensorTypeCd.trim() == "T")
                                                return Formatters.TemperatureSensorFormatterForExcel(params);
                                            else
                                                return Formatters.DigitalSensorFormatterForExcel(params);
                                        }
                                        else
                                            returnValue = "-NA-";
                                    }
                                    else
                                        returnValue = "-NA-";
                                }
                            }
                        }
                        break;
                    case 'HumiditySetpoint':
                        {
                            if (params.value != undefined && params.value != null) {
                                returnValue = Formatters.HumiditySetpointForExcel(params.value, params.node.data.HumiditySetpointStatus);
                            }
                        }
                        break;
                    case 'EverFRESH':
                        {
                            if (params.value != undefined && params.value != null) {
                                returnValue = Formatters.EverFreshFormatterExcel(params.value);
                            }
                        }
                        break;
                    default: {
                        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
                            returnValue = params.value;
                        }
                        else if (params.column.colId === "0") {
                            return "";
                        }
                        else
                            returnValue = "-NA-";
                    }
                }

                return returnValue;
            }

        }
        else {
            if (params.node.group && ProcessfirstCellOnlyRowIndex != params.node.rowGroupIndex) {
                ProcessfirstCellOnlyRowIndex = params.node.rowGroupIndex
                if (params.node.key != null && params.node.key != undefined)
                    return self.myRowGroupCallback(params);
            }

            if (params.node.group && params.column.colId === "0") {
                return self.myRowGroupCallback(params);
            }

            if (!params.node.group) {
                switch (params.column.colId) {
                    case 'RCDID': case 'RCDId': case 'TowerBaseStationID': case 'ICCID': case 'MSISDN': case 'SIM_IMSI': case 'RcdID': case 'Value1':
                    case 'Value3': case 'Value4':
                        {
                            if (params.value == undefined || params.value == "-NA-")
                                returnValue = "-NA-";
                            else
                                returnValue = params.value;
                        }
                        break;
                    case 'CO2Setpoint': case 'CO2Reading': case 'O2Setpoint': case 'O2Reading': case 'EvaporatorTemp':
                    case 'CompositeSuctionPressure': case 'CompressorSuctionTemp': case 'DischargePressure': case 'CompressorDischargeTemp':
                    case 'CondenserTemperature': case 'CondenserFanOutPut': case 'LowSpeedEvaporatorFanOutPut': case 'HighSpeedEvaporatorFanOutPut':
                    case 'HeaterOnTime': case 'HotGasValveOpening': case 'EconomizerValveOpening': case 'CompressorFrequency': case 'CompressorCurrent': case 'VentPositionSensorCMH':
                    case 'TotalCurrentDraw': case 'LineVoltage1': case 'LineVoltage2': case 'LineVoltage3': case 'VFD': case 'CompressorCurrent':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.sensorDataFormatterforExcel(params.value);
                            else
                                returnValue = "-NA-";
                        }
                        break;
                    case 'LineFrequency' :
                    {
                        var OEMTypeCd;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            OEMTypeCd = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].ReeferOEMTypeCd;
                        }
                        if(OEMTypeCd != null && OEMTypeCd != undefined) {
                            if(OEMTypeCd.toString().toUpperCase().trim() == "D" && (params.node.data.ControllerTypeCd == 27 || params.node.data.ControllerTypeCd == 28 || params.node.data.ControllerTypeCd == 32))
                                if (params.value != undefined && params.value != null && params.value != '-NA-')
                                    returnValue = Formatters.lineFrequencyFormatterforExcel(params.node.data.LineFrequencyQualifier, params.value);
                                else
                                    returnValue = "-NA-";
                            else   {
                                if (params.value != undefined && params.value != null)
                                returnValue = Formatters.sensorDataFormatterforExcel(params.value);
                            else
                                returnValue = "-NA-";
                            }                                

                        }
                        else {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.sensorDataFormatterforExcel(params.value);
                            else
                                returnValue = "-NA-";
                         }
                    }
                    break;
                    case 'SetPoint': case 'SupplyTemp1': case 'SupplyTemp2': case 'ReturnTemp1': case 'ReturnTemp2':
                    case 'AmbientTemp': case 'EvaporatorInletSensor': case 'EvaporatorOutletSensor': case 'CompressorSuctionTemp': case 'CompressorDischargeTemp':
                    case 'CondenserTemperature': case 'USDA1Temp': case 'USDA2Temp': case 'USDA3Temp': case 'Cargo4Temp': case 'SensorSupplyTemp1': case 'SensorReturnTemp1':
                    case 'CTTempLimit': case 'CTPostSetPoint': case 'CompressorDischargeTemp2': case 'EconomizerInTemp': case 'EconomizerOutTemp'://RCNG-1818
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.TemperatureFormatterforExcel(params.value);
                            else
                                returnValue = "-NA-";
                        }
                        break
                    case 'DeviceTemp': case 'InsideTemp':
                        {
                            if (params != undefined && params != null)
                                returnValue = Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                            else
                                returnValue = "-NA-";
                        }
                        break
                    case 'XAxis': case 'YAxis': case 'ZAxis':
                        {
                            return Formatters.GravityVectorValueFormatter(params);
                        }
                        break
                    case 'Illumination':
                        {
                            return Formatters.LuxValueFormatter(params);
                        }
                        break
                    case 'TemperatureUnit':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.TemperatureFormatterForBookingforExcel(params.value);
                            else
                                returnValue = "-NA-";
                        }
                        break
                    case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM': case 'DLEventDTTM':
                    case 'CreatedDTTM': case 'CreateDTTM': case 'StatusDate': case 'SubmittedOn': case 'EndDate': case 'scheduledCreatedDTTM':
                    case 'StartDate': case 'LastPreTripDTTM': case 'PTRDateTime': case 'TTL': case 'GPSDTTM': case 'DeviceDataTime': case 'ExpirationTime':
                    case 'EarliestDepartureDtm': case 'ArrivalDtm': case 'TWTime': case 'DoorEventDtm': case 'Door1EventDttm':
                    case 'TripStart': case 'TripEnd': case "CTTime":
                        {
                            //if (params.value != undefined && params.value != null)
                            returnValue = Formatters.dateTypeFormatterforExcel(params.value);
                        }
                        break
                    case 'Name': case 'Description': case 'RCDBootloaderVersion': case 'PTResult': case 'VesselCd': case 'DeviceType':
                    case 'GeofenceTag': case 'VesselName': case 'Origin': case 'Handler': case 'TripStatusCdAndDFlag':
                    case 'UserName': case 'TagName': case 'Created': case 'DeploymentName': case 'CreatedBy': case 'ModifiedBy': case 'SubmittedBy':
                    case 'FullName': case 'Zip': case 'CCSeverityLevelGenset': case 'OEMModel': 
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.stringTypeFormatterChildFormsNew(params.value);
                            else
                                returnValue = "-NA-";
                        }
                        break;
                    case 'DimiStartAfter':
                        returnValue = Formatters.OEMPTITypeFormatter(params.value);
                        break;
                    case 'CommentExists': case 'CommentExistsGenset': case 'CommentExistsDC': case 'CommentExistsChassis':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.CommentExistsforExcel(params.value);
                        }
                        break;
                    case 'PossibleDamage': 
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.PossibleDamageForExcel(params.value);
                        }
                        break;
                    case 'IsInsideGeofence': case 'IsActive': case 'HasOilPressureSwitch':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.YesNoConverterforExcel(params.value);
                        }
                        break
                    case 'ReeferOEMTypeCd': case 'ÓEMTypeCD':
                        {
                            //if (params.value != undefined && params.value != null)
                            returnValue = Formatters.GetOEMTypeDescription(params.value);
                        }
                        break;
                    case 'GPSHDOP':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSHDOPTypeFormatterForExcel(params.node.data.GPSHDOP, params.node.data.GPSLockState);
                        }
                        break;
                    case 'GPSSatelliteCount':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSSatCountTypeFormatterForExcel(params.node.data.GPSSatelliteCount, params.node.data.GPSLockState);
                        }
                        break;
                    case 'DryGPSHDOP':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSHDOPTypeFormatterForExcel(params.node.data.DryGPSHDOP, params.node.data.GPSLockState);
                        }
                        break;
                    case 'PositionAccuracy':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSAcctypeFormatterForExcel(params.node.data.PositionAccuracy);
                        }
                        break;
                    case 'DryGPSSatelliteCount':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSSatCountTypeFormatterForExcel(params.node.data.DryGPSSatelliteCount, params.node.data.GPSLockState);
                        }
                        break;
                    case 'ChassisGPSHDOP':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSHDOPTypeFormatterForExcel(params.node.data.ChassisGPSHDOP, params.node.data.GPSLockState);
                        }
                        break;
                    case 'ChassisGPSSatelliteCount':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GPSSatCountTypeFormatterForExcel(params.node.data.ChassisGPSSatelliteCount, params.node.data.GPSLockState);
                        }
                        break;
                    case 'ExtBattVoltage': case 'BattVoltage': case 'DeviceBattery': case 'BatteryVoltage': case 'DoorSensorBatteryVoltage':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.BattVoltageFormatterforExcel(params.value);
                        }
                        break;
                    case 'Door1BattPct':
                        {
                            returnValue = Formatters.DoorBattPctFormatterforExcel(params.node.data.Door1BattPct); //door1BattPct);
                        }
                        break;
                    case 'BatteryPct':
                        {
                            returnValue = Formatters.DoorBattPctFormatterforExcel(params.node.data.BatteryPct); 
                        }
                        break;
                    case 'ReeferBatteryPct':
                        {
                            returnValue = Formatters.ReeferBattPctFormatterforExcel(params.node.data.ReeferBatteryPct, params.node.data.DeviceType);
                        }
                        break;
                    case 'DeviceConfig': case 'GuestReeferMode':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.GuestReeferModeFormatterForExcel(params.value);
                        }
                        break;
                    case 'DrySpeed': case 'ChassisSpeed': case 'Speed':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.SpeedConverterforExcel(params.value);
                        }
                        break;
                    case 'RCDPOWERSOURCECD': if (params.value != undefined && params.value != null) returnValue = Formatters.rcdPowerSourceFormatterforExcel(params.value);
                        break;
                    case 'RunState': if (params.value != undefined && params.value != null) returnValue = Formatters.RunStateFormatterGroupingForExcel(params.value);
                        break;
                    case 'AssetState': if (params.value != undefined && params.value != null) returnValue = Formatters.AssetStateFormatterGroupingForExcel(params.value);//Asset State changes
                        break;
                    case 'R_HighestSeverityLevel': {
                        if (params.value != undefined && params.value != null)
                            returnValue = Formatters.statusIndicatorforALMforExcel(params.value);
                    }
                        break;
                    case 'MASeverityLevel':
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.statusIndicatorforALMforExcel(params.node.data.MASeverityLevel);
                        }
                        break;
                    case 'AlertSeverityID': if (params.value != undefined && params.value != null) returnValue = Formatters.statusIndicatorforALRforExcel(params.value); break;
                    case 'IsOnVessel': if (params.value != undefined && params.value != null) returnValue = Formatters.isOnVesselFormatterChildForms(params.value); break;
                    case 'GPSLastLock': if (params.value != undefined && params.value != null) returnValue = Formatters.secondsToTimeConverterForExcel(params.node.data.GPSLastLock); break;
                    case 'AlarmsList': if (params.value != undefined && params.value != null) returnValue = Formatters.AlarmListFormatterforExcel(params.value); break;
                    case 'TemperatureUnit': if (params.value != undefined && params.value != null) returnValue = Formatters.TemperatureFormatterForBookingforExcel(params.value); break;
                    case 'ThreePhaseCurrent': if (params.value != undefined && params.value != null) returnValue = Formatters.Current3PhaseFormatterforExcel(params.value); break;
                    case 'FilerepositoryActionCD': if (params.value != undefined && params.value != null) returnValue = Formatters.GetFileRepositoryActionDesc(params.value); break;
                    case 'GeofenceCategoryCd': if (params.value != undefined && params.value != null) returnValue = Formatters.fenceTypeFormatterForExcel(params.value); break;
                    case 'IgnitionOn': if (params.value != undefined && params.value != null) returnValue = Formatters.gensetSwitchFormatterForExcel(params.value); break;
                    case 'BatteryStatus': if (params.value != undefined && params.value != null) returnValue = Formatters.ChassisBatteryStatusFormatterForExcel(params.node.data.BatteryStatus); break;
                    case 'ChassisBatteryStatus': if (params.value != undefined && params.value != null) returnValue = Formatters.ChassisBatteryStatusFormatterForExcel(params.node.data.ChassisBatteryStatus); break;
                    case 'BreakSignal': if (params.value != undefined && params.value != null) returnValue = Formatters.BrakeSignalFormatterForExcel(params.value); break;
                    case 'TripWiseExpiration': if (params.value != undefined && params.value != null) returnValue = Formatters.TripWiseExpirationFormatterforExcel(params.value); break;
                    case 'DimiRemainTerm':case 'DimiTerm': if (params.value != undefined && params.value != null) returnValue = Formatters.DimiRemainTermFormatterforExcel(params.value); 
                    break;
                    case 'AirPumpRunHours': if (params.value != undefined && params.value != null) returnValue = Formatters.AirPumpRunHoursFormatterforExcel(params.value); break;
                    case 'CompressorRunHours': if (params.value != undefined && params.value != null) returnValue = Formatters.CompressorRunHoursFormatterforExcel(params.value); break;
                    case 'CARunHours': if (params.value != undefined && params.value != null) returnValue = Formatters.CARunHoursFormatterforExcel(params.value); break;                        
                    case 'PowerMeter': if (params.value != undefined && params.value != null) returnValue = Formatters.PowerMeterFormatterforExcel(params.value); break;                        
                    case 'CASoftwareRevision': if (params.value != undefined && params.value != null) returnValue = Formatters.CASWVerFormatterforExcel(params.value); break;                        
                    case 'CTDuration': if (params.value != undefined && params.value != null) returnValue = Formatters.CTDurationorRemainingTimeFormatterforExcel(params.value); break;//RCNG-1818
                    case 'CTRemainingTime': if (params.value != undefined && params.value != null) returnValue = Formatters.CTDurationorRemainingTimeFormatterforExcel(params.value); break;//RCNG-1818
                    case 'CustomerName': if (params.value != undefined && params.value != null) returnValue = Formatters.stringTypeFormatterFor3PExcel(params.value); break;
                    case 'TWState': if (params.value != undefined && params.value != null) returnValue = Formatters.tripWiseFormatterForExcel(params); break;
                    //case 'PWR': if (params.value != undefined && params.value != null) returnValue = Formatters.pwrStateFormatterChassisforExcel(params.node.data.PWR); break;
                    case 'PWR': case 'DryPWR': if (params.value != undefined && params.value != null) returnValue = Formatters.pwrStateFormatterChassisforExcel(params.value); break;
                    case 'Loaded': if (params.value != undefined && params.value != null) returnValue = Formatters.LoadedFormatterForExcel(params.value); break;
                    case "RSSI": if (params.value != undefined && params.value != null) returnValue = params.node.data.RSSI; break;
                    case 'FractionDisplay': {
                        if (params.value != undefined && params.value != null) {
                            var FuelLevelQualifier;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                FuelLevelQualifier = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].FuelLevelQualifier;
                            }
                            else {
                                FuelLevelQualifier = "";
                            }

                            var FractionDisplay;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                FractionDisplay = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].FractionDisplay;
                            }
                            else {
                                FractionDisplay = false;
                            }
                            var HasFuelSensor;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                HasFuelSensor = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HasFuelSensor;
                            }
                            else {
                                HasFuelSensor = false;
                            }

                            var isFuelinfo = {
                                FuelLevelQualifier: FuelLevelQualifier,
                                FractionDisplay: FractionDisplay,
                                HasFuelSensor: HasFuelSensor
                            };

                            if (FuelLevelQualifier != undefined && FuelLevelQualifier != null &&
                                //FractionDisplay != undefined && FractionDisplay != null &&
                                HasFuelSensor != undefined && HasFuelSensor != null)
                                returnValue = Formatters.FillLevelTraceFormatterforExcel(isFuelinfo);
                        }
                    }
                        break;
                    case 'HasFuelSensor': {
                        if (params.value != undefined && params.value != null) {
                            var FuelLevelQualifier;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                FuelLevelQualifier = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].FuelLevelQualifier;
                            }
                            else {
                                FuelLevelQualifier = "";
                            }

                            var FuelLevelQualifierDesc;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                FuelLevelQualifierDesc = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].FuelLevelQualifierDesc;
                            }
                            else {
                                FuelLevelQualifierDesc = "";
                            }

                            var isFuelinfo2 = {
                                HasFuelSensor: params.value,
                                FuelLevelQualifier: FuelLevelQualifier,
                                FuelLevelQualifierDesc: FuelLevelQualifierDesc
                            };

                            if (FuelLevelQualifier != undefined && FuelLevelQualifier != null)
                                returnValue = Formatters.FuelSensorTraceFormatterforExcel(isFuelinfo2);
                        }
                        break;
                    }
                    case 'ManufacturedDate':
                        {
                            if (params.value != undefined && params.value != null) returnValue = Formatters.YearFromdateTypeFormatterForExcelNew(params.value);
                        }
                        break;
                    case 'AssetType': returnValue = Formatters.AssetTypeFormatterForExcel(params.value); break;
                    case 'PreTrip': {
                        if (params.value != undefined && params.value != null) {
                            if (this.state.formName == "PreTrip")
                                returnValue = Formatters.PTIStateforExcel(params.value);
                            else
                                returnValue = Formatters.stringTypeFormatterChildForms(params.value);
                        }
                    }
                        break;
                    case 'CCSeverityLevel':
                        {
                            if (params.value != undefined && params.value != null) {

                                var IsCargoCare;
                                //IsCargocare = self.getOtherColumnCellValue(params, "IsCargocare");
                                //if (params.node.rowIndex != undefined && params.node.rowIndex != null) {
                                //if (self.state.excelGridData[params.node.rowIndex].IsCargoCare != undefined
                                //    && self.state.excelGridData[params.node.rowIndex].IsCargoCare != null)
                                //IsCargocare = self.state.excelGridData[params.node.rowIndex].IsCargoCare;
                                //if (self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null)
                                //    IsCargoCare = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].IsCargoCare;                                    
                                //}
                                if (params.node != undefined && params.node != null && params.node.data != undefined && params.node.data != null) {
                                    IsCargoCare = params.node.data.IsCargoCare;  //RCNG-241 Renamed Normal to Assigned
                                }
                                else {
                                    IsCargoCare = false;
                                }
                                if (IsCargoCare != undefined && IsCargoCare != null)
                                    returnValue = Formatters.CargoCareFormatterforExcel({ isCargocare: IsCargoCare, CCSeverityLevel: params.value });
                            }
                        }
                        break;
                    case 'DoorOpen'://RCNG-1106
                        {
                            if (params.value != undefined && params.value != null) {
                                //var HasDoorSensor;
                                //if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                //    HasDoorSensor = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HasDoorSensor;
                                //}
                                //else {
                                //    HasDoorSensor = false;
                                //}
                                //if (HasDoorSensor != undefined && HasDoorSensor != null)
                                //   returnValue = Formatters.DoorFormatterExcel({ Door1Open: params.value, HasDoorSensor: HasDoorSensor });

                                returnValue = reeferFormatters.DoorFormatterExcel(params.value);
                            }
                        }
                        break;
                    case 'Door1Open':
                        {
                            if (params.value != undefined && params.value != null) {
                                returnValue = Formatters.Door1FormatterExcel(params.value); //RCNG-2377
                            }
                            else
                                returnValue = '-NA-';
                        }
                        break;
                    case 'Humidity':
                        {
                            if (params.value != undefined && params.value != null) {
                                var HumiditySetpointStatus;
                                //HumiditySetpointStatus1 = this.getOtherColumnCellValue(params, "HumiditySetpointStatus");
                                if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                    HumiditySetpointStatus = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HumiditySetpointStatus;
                                }
                                else {
                                    HumiditySetpointStatus = "";
                                }

                                if (HumiditySetpointStatus != undefined && HumiditySetpointStatus != null)
                                    returnValue = Formatters.HumiditySettingFormatterforExcel({ Humidity: params.value, HumiditySetpointStatus: HumiditySetpointStatus });
                                else
                                    returnValue = '-NA-'; // WI 26545
                            }
                        }
                        break;
                    case 'ControlledAtmosphereMode': {
                        if (params.value != undefined && params.value != null) {
                            var ReeferOEMTypeCd;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                ReeferOEMTypeCd = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].ReeferOEMTypeCd;
                            }
                            else {
                                ReeferOEMTypeCd = "";
                            }

                            if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null)
                                returnValue = Formatters.ControlledAtmosphereModeforExcel({ ReeferOEMTypeCd: ReeferOEMTypeCd, ControlledAtmosphereMode: params.value });
                        }
                    }
                        break;
                    case 'SuctionModulationValveOpening': {
                        if (params.value != undefined && params.value != null) {
                            var ReeferOEMTypeCd;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                ReeferOEMTypeCd = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].ReeferOEMTypeCd;
                            }
                            else {
                                ReeferOEMTypeCd = "";
                            }

                            var SuctionModulationValveOpeningQualifier;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                SuctionModulationValveOpeningQualifier = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].SuctionModulationValveOpeningQualifier;
                            }
                            else {
                                SuctionModulationValveOpeningQualifier = "";
                            }

                            var SuctionModulationValveOpeningData = {
                                ReeferOEMTypeCd: ReeferOEMTypeCd,
                                SuctionModulationValveOpeningQualifier: SuctionModulationValveOpeningQualifier,
                                SuctionModulationValveOpening: params.value
                            };

                            if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null && SuctionModulationValveOpeningQualifier != undefined && SuctionModulationValveOpeningQualifier != null)
                                returnValue = Formatters.sensorDataOpenSucFormatterForExcel(SuctionModulationValveOpeningData);
                        }
                    }
                        break;
                    case 'CondenserPressure': {
                        if (params.value != undefined && params.value != null) {
                            var ReeferOEMTypeCd;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                ReeferOEMTypeCd = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].ReeferOEMTypeCd;
                            }
                            else {
                                ReeferOEMTypeCd = "";
                            }

                            if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null)
                                returnValue = Formatters.sensorDataPCondFormatterExcel({ ReeferOEMTypeCd: ReeferOEMTypeCd, CondenserPressure: params.value });
                        }
                    }
                        break;
                    case 'EvaporatorExpansionValveOpening': {
                        if (params.value != undefined && params.value != null) {
                            var ReeferOEMTypeCd;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                ReeferOEMTypeCd = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].ReeferOEMTypeCd;
                            }
                            else {
                                ReeferOEMTypeCd = "";
                            }
                            var EEVData = {
                                ReeferOEMTypeCd: ReeferOEMTypeCd,
                                EvaporatorExpansionValveOpening: params.value
                            };
                            if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null)
                                returnValue = Formatters.sensorDataOpenExpFormatterExcel(EEVData);
                        }
                    }
                        break;
                    case 'GensetRunning': {
                        if (params.value != undefined && params.value != null) {
                            // Start WI-26787
                            //var HasOilPressureSwitch;
                            //if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            //    HasOilPressureSwitch = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HasOilPressureSwitch;
                            //}
                            //else {
                            //    HasOilPressureSwitch = false;
                            //}

                            //if (HasOilPressureSwitch != undefined && HasOilPressureSwitch != null)
                            //    returnValue = Formatters.gensetRunningFormatterforExcel({ GensetRunning: params.value, HasOilPressureSwitch: HasOilPressureSwitch });
                            var isGensetRunning = {
                                GensetRunning: params.node.data.GensetRunning,
                                HasOilPressureSwitch: params.node.data.HasOilPressureSwitch,
                                OEMTypeCD: params.node.data.OEMTypeCD
                            };
                            returnValue = Formatters.EngFormatterforExcel(isGensetRunning);
                            // End WI-26787
                        }
                    }
                        break;
                    case 'FuelLevel': {
                        if (params.value != undefined && params.value != null) {
                            var FuelLevelQualifier;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                FuelLevelQualifier = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].FuelLevelQualifier;
                            }
                            else {
                                FuelLevelQualifier = "";
                            }
                            var FuelLevelQualifierDesc;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                FuelLevelQualifierDesc = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].FuelLevelQualifierDesc;
                            }
                            else {
                                FuelLevelQualifierDesc = "";
                            }
                            var FractionDisplay;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                FractionDisplay = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].FractionDisplay;
                            }
                            else {
                                FractionDisplay = false;
                            }
                            var HasFuelSensor;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                HasFuelSensor = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HasFuelSensor;
                            }
                            else {
                                HasFuelSensor = false;
                            }

                            var isFuelinfo3 = {
                                FuelLevel: params.value,
                                FuelLevelQualifier: FuelLevelQualifier,
                                FuelLevelQualifierDesc: FuelLevelQualifierDesc,
                                FractionDisplay: FractionDisplay,
                                HasFuelSensor: HasFuelSensor
                            };
                            if (FuelLevelQualifier != undefined && FuelLevelQualifier != null &&
                                //FuelLevelQualifierDesc != undefined && FuelLevelQualifierDesc != null &&
                                //FractionDisplay != undefined && FractionDisplay != null &&
                                HasFuelSensor != undefined && HasFuelSensor != null)
                                returnValue = Formatters.FillLevelGalTraceFormatterforExcel(isFuelinfo3);
                        }
                    }
                        break;
                    case 'DevicePowerSourceCd': {
                        if (params.value != undefined && params.value != null) {
                            //var DeviceConfig;
                            //if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            //    DeviceConfig = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceConfig;
                            //}
                            //else {
                            //    DeviceConfig = false;
                            //}

                            //var DeviceType;
                            //if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            //    DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                            //}
                            //else {
                            //    DeviceType = "";
                            //}

                            var ispwrStateFormatter = {
                                DeviceType: params.node.data.DeviceConfig,
                                DevicePowerSourceCd: params.node.data.DevicePowerSourceCd,
                                DeviceTypeCd: params.node.data.DeviceType
                            };
                            
                            //if (DeviceType != undefined && DeviceType != null && DeviceConfig != undefined && DeviceConfig != null)
                            returnValue = Formatters.pwrStateFormatterforExcel(ispwrStateFormatter);
                        }
                    }
                        break;
                    case 'Door1OpenChassis': {
                        if (params.value != undefined && params.value != null) {
                            var HasDoorSensor;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                                && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                                HasDoorSensor = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HasDoorSensor;
                            }
                            else {
                                HasDoorSensor = false;
                            }

                            var door1ChassisStateFormatter = {
                                HasDoorSensor: HasDoorSensor,
                                Door1OpenChassis: params.value
                            };

                            if (HasDoorSensor != undefined && HasDoorSensor != null)
                                returnValue = Formatters.DoorFormatterChassisforExcel(door1ChassisStateFormatter);
                        }
                    }
                        break;
                    case "GPSCoords":
                        return Formatters.GPSCoordsFormatterGroupingForExcel(params);
                    case "Sensor1Value_GT1200": case "Sensor2Value_GT1200": case 'Sensor3Value_GT1200': case 'Sensor4Value_GT1200': case "Sensor5Value_GT1200": case "Sensor6Value_GT1200": case 'Sensor7Value_GT1200': case 'Sensor8Value_GT1200':
                    case "Sensor1Value_GT1020": case "Sensor2Value_GT1020": case 'Sensor3Value_GT1020': case 'Sensor4Value_GT1020': case "Sensor5Value_GT1020": case "Sensor6Value_GT1020": case 'Sensor7Value_GT1020': case 'Sensor8Value_GT1020':
                    case "Sensor1Value_ST9100": case "Sensor2Value_ST9100": case 'Sensor3Value_ST9100': case 'Sensor4Value_ST9100': case "Sensor5Value_ST9100": case "Sensor6Value_ST9100": case 'Sensor7Value_ST9100': case 'Sensor8Value_ST9100':
                    case "Sensor1Value_GT1030": case "Sensor2Value_GT1030": case 'Sensor3Value_GT1030': case 'Sensor4Value_GT1030': case "Sensor5Value_GT1030": case "Sensor6Value_GT1030": case 'Sensor7Value_GT1030': case 'Sensor8Value_GT1030':
                        {
                            if (params.value != undefined && params.value != null) {
                                if (self.state.sensorData != undefined && self.state.sensorData != null) {
                                    var columnFieldName = params.column.colId;
                                    var deviceType = params.node.data.DeviceType;
                                    var name = columnFieldName.split("_");
                                    var fieldName = name[0];
                                    var value = params.node.data[name[0]];

                                    if (value != null && value != undefined && deviceType != null) {//RCNG-1578
                                        var sensorcolumn = self.state.sensorData.filter(x => x.FieldName == fieldName && x.DeviceTypeCd.trim() == deviceType.trim());
                                        if (sensorcolumn[0] != undefined && sensorcolumn[0] != null) {
                                            if (sensorcolumn[0].SensorTypeCd.trim() == "T")
                                                return Formatters.TemperatureSensorFormatterForExcel(params);
                                            else
                                                return Formatters.DigitalSensorFormatterForExcel(params);
                                        }
                                        else
                                            returnValue = "-NA-";
                                    }
                                    else
                                        returnValue = "-NA-";
                                }
                            }
                        }
                        break;
                    case 'HumiditySetpoint':
                        {
                            if (params.value != undefined && params.value != null) {
                                returnValue = Formatters.HumiditySetpointForExcel(params.value, params.node.data.HumiditySetpointStatus);
                            }
                        }
                        break;
                    case 'EverFRESH':
                        {
                            if (params.value != undefined && params.value != null) {
                                returnValue = Formatters.EverFreshFormatterExcel(params.value);
                            }
                        }
                        break;
                    default: {
                        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
                            returnValue = params.value;
                        }
                        else if (params.column.colId === "0") {
                            return "";
                        }
                        else
                            returnValue = "-NA-";
                    }
                }

                return returnValue;
            }
        }
    }

    myGroupHeaderCallback(params) {

        var displayName = params.columnApi.getDisplayNameForColumnGroup(
            params.columnGroup
        );
        return displayName;//.toUpperCase();
    }

    getRequiredParams() {
        if (this.state.isIncludeRowGroup) {
            if (columnsToBeExported != null) {
                return {
                    columnGroups: true,
                    columnKeys: columnsToBeExported,
                    processRowGroupCallback: this.myRowGroupCallback,
                    processCellCallback: this.myCellCallback,
                    processGroupHeaderCallback: this.myGroupHeaderCallback,
                    processHeaderCallback: this.myHeaderCallback,
                    fileName: this.getFileName(this.GetExportFileName())

                };
            }
            else {
                return {
                    columnGroups: true,
                    allColumns: true,
                    processCellCallback: this.myCellCallback,
                    processGroupHeaderCallback: this.myGroupHeaderCallback,
                    processHeaderCallback: this.myHeaderCallback,
                    processRowGroupCallback: this.myRowGroupCallback,
                    fileName: this.getFileName(this.GetExportFileName())
                };
            }
        }
        else {

            if (columnsToBeExported != null) {
                return {
                    columnGroups: false,
                    processCellCallback: this.myCellCallback,
                    columnKeys: columnsToBeExported,
                    processHeaderCallback: this.myHeaderCallback,
                    fileName: this.getFileName(this.GetExportFileName())
                };
            }
            else {
                return {
                    columnGroups: false,
                    processCellCallback: this.myCellCallback,
                    processHeaderCallback: this.myHeaderCallback,
                    allColumns: true,
                    fileName: this.getFileName(this.GetExportFileName())
                };
            }
        }
    }

    getParams() {
        
        //var a = this.getRequiredParams();
        //return a;
        return {
            columnGroups: true,
            allColumns: true,
            processRowGroupCallback: this.myRowGroupCallback,
            processCellCallback: this.myCellCallback,
            processGroupHeaderCallback: this.myGroupHeaderCallback,
            processHeaderCallback: this.myHeaderCallback,
            fileName: this.getFileName(this.GetExportFileName())

        };
        /*
        if (this.state.isIncludeRowGroup) {
            if (columnsToBeExported != null) {
                return {
                    columnGroups: true,
                    columnKeys: columnsToBeExported,
                    processRowGroupCallback: this.myRowGroupCallback,
                    processCellCallback: this.myCellCallback,
                    processGroupHeaderCallback: this.myGroupHeaderCallback,
                    processHeaderCallback: this.myHeaderCallback,
                    fileName: this.getFileName(this.GetExportFileName())
                    
                };
            }
            else {
                return {
                    columnGroups: true,
                    allColumns: true,
                    processCellCallback: this.myCellCallback,
                    processGroupHeaderCallback: this.myGroupHeaderCallback,
                    processHeaderCallback: this.myHeaderCallback,
                    processRowGroupCallback: this.myRowGroupCallback,
                    fileName: this.getFileName(this.GetExportFileName())
                };
            }
        }
        else {

            if (columnsToBeExported != null) {
                return {
                    columnGroups: false,
                    processCellCallback: this.myCellCallback,
                    columnKeys: columnsToBeExported,
                    fileName: this.getFileName(this.GetExportFileName())
                };
            }
            else {
                return {
                    columnGroups: false,
                    processCellCallback: this.myCellCallback,
                    allColumns: true,
                    fileName: this.getFileName(this.GetExportFileName())
                };
            }
        }
        */
    }

    exportDataAsExcel() {
        //this.props.api.exportDataAsExcel(this.getParams());
    }

    ExportDataAsExcel() {
        //var params = this.getParams();

        //gridOptions.api.exportDataAsExcel(params);
    }



    public render() {
        var rowGroupLength = this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length;
        var onlyselected = this.props.onlyselected;
        return <div>

            <div>

                <div className="row p-3">
                    <div className='col-md-3 col-lg-3 col-sm-3 text-start text-sm-end pe-0'>
                        <label>Select the export mode:</label>
                    </div>
                    <div className='col-md-8 col-lg-8 col-sm-8 col-xs-8'>
                        <div className='form-check form-check-inline'>
                            <input type="radio" id="option1" value="AllColumns" className='form-check-input'
                                checked={this.state.selectedOption === 'AllColumns'}
                                onChange={this.handleOptionChange}
                            //onClick={(e) => this.SelectedOption('AllDefaultColumns')}
                            /> <span className='form-check-label'>All Columns</span>
                        </div>
                        <div className='form-check form-check-inline'>
                            <input type="radio" id="option2" value="SelectedColumns" className='form-check-input'
                                checked={this.state.selectedOption === 'SelectedColumns'}
                                onChange={this.handleOptionChange}
                                disabled={!(this.state.isUserPreference)}
                            //onClick={(e) => this.SelectedOption('SelectedColumns')}
                            />
                            <span className='form-check-label'> Grid Preference Columns </span>
                        </div>
                    </div>
                    {/*
                    <div>
                        Selected option is : {this.state.selectedOption}
                    </div>
                   */}
                </div>

                {onlyselected ? "" :
                    rowGroupLength > 0 ?
                        <div className='checkbox includeRowGroups'>
                            <div className="form-check form-check-inline">
                                <input type='checkbox' className=' form-check-input chkIncludeRowGroup' checked={this.state.isIncludeRowGroup}
                                    id='chkIncludeRowGroup' onChange={this.onChangeIncludeRowGroup} />
                                <label className="form-check-label">
                                    Include Row Group(s)
                                </label>
                            </div>



                            {this.state.isIncludeRowGroup ? <div className="form-check form-check-inline">
                                <input type='checkbox' className='form-check-input chkIncludeColumnGroup' checked={this.state.isIncludeColumnGroup}
                                    id='chkIncludeColumnGroup' onChange={this.onChangeIncludeColumnGroup} />
                                <label className="form-check-label">
                                    Include Column Group(s)
                                </label>
                            </div> : ""}



                        </div>

                        : ""}



            </div>

            <div className="modal-footer">
                <button type="button" id="hidePopUpBtn" className="btn btn-secondary" onClick={this.no.bind(this)}>Cancel</button>
                <button type="button" id="btnYes" className="btn btn-primary" onClick={this.yes.bind(this)}>Save</button>
            </div>

            <Workbook filename={this.state.fileTitle + ".xlsx"} element={<button id="btnDownloadReeferExcel1" className="btn btn-lg btn-primary d-none"></button>}>
                {this.state.sheetInfo}
            </Workbook>
        </div>;

        //return <div className="modal" id="confirmPopUpModel" role="dialog">
        //    <div className="modal-dialog">
        //        <div className="modal-content">
        //            <div className="modal-header">
        //                <button type="button" className="btn-close" onClick={this.closePopUp.bind(this)}>&times;</button>
        //                <h4 className="modal-title">Export to Excel Confirmation </h4>
        //            </div>
        //            <div className="modal-body">
        //                {

        //                    <div>
        //                        Do you want export with
        //                            <div className="row">
        //                                <div className='col-md-12'>
        //                                <input type="radio" name="options" id="option1" value="AllColumns" onClick={(e) => this.SelectedOption('AllDefaultColumns')}/> All Default Columns
        //                                </div>
        //                            </div>
        //                            <div className="row">
        //                                <div className='col-md-12'>
        //                                <input type="radio" name="options" id="option2" value="SelectedColumns" onClick={(e) => this.SelectedOption('SelectedColumns')} /> Selected Columns
        //                                </div>
        //                            </div>
        //                        </div>

        //                }
        //            </div>
        //            <div className="modal-footer">
        //                <button type="button" id="btnYes" className="btn btn-secondary" onClick={this.yes.bind(this)}>Save</button>
        //                <button type="button" id="hidePopUpBtn" className="btn btn-primary" onClick={this.no.bind(this)}>Cancel</button>
        //            </div>
        //        </div>


        //    </div>
        //    <div className='aggrid-icons-bg'>
        //        <div className="btn-group aggrid-icons">
        //    <Workbook filename={this.state.fileTitle + ".xlsx"} element={<button id="btnDownloadReeferExcel" className="btn btn-lg btn-primary hidden"></button>}>
        //        {this.state.sheetInfo}
        //    </Workbook>
        //            </div></div>
        //</div>

    }

    ExportToExcel(exportColumns, optionId) {
        var arrData;
        if (this.props.gridData != undefined && this.props.gridData != null && this.props.gridData.length > 0) {
            arrData = typeof this.props.gridData != 'object' ? JSON.parse(this.props.gridData) : this.props.gridData;
            $("#globalLoader").show();
            //WI-21469 - start
            if (arrData.length > 0) {
                var i;
                var valueString = "";
                for (i = 0; i < arrData.length; i++) {
                    if (arrData[i].RunningMode != 'undefined' && arrData[i].RunningMode != null) {
                        var inputValue = arrData[i].RunningMode;

                        if (inputValue != null && inputValue != undefined && inputValue != '') {
                            valueString = inputValue.replace('/^\s+/g', '');
                            if (valueString.startsWith(",")) {
                                valueString = valueString.substring(1, valueString.length);
                            }

                            if (valueString.endsWith(",")) {
                                valueString = valueString.substring(0, valueString.length - 1);
                            }

                            if (valueString != "") {
                                arrData[i].RunningMode = valueString;
                            }
                        }
                    }
                }
            }
            //WI-21469 - end

            var arrayToBeExported: any[];
            var tempClone: any[];
            tempClone = this.props.colDefs;

            var tempClone2: any[];
            tempClone2 = this.props.colDefs2;

            if (exportColumns != null) {

                if (optionId === 2) {
                    for (var loopvariable = 0; loopvariable < this.props.colDefs.length; loopvariable++) {

                        for (var children = 0; children < this.props.colDefs[loopvariable].children.length; children++) {
                            if (exportColumns.indexOf(this.props.colDefs[loopvariable].children[children].field) >= 0) {
                                //Exists, do nothing. be part of export array
                            }
                            else {
                                //not exists, removed from export array
                                // var b = r1[loopvariable].children;
                                tempClone[loopvariable].children.splice(children, 1)
                                children = children - 1;
                            }
                        }
                    }

                    arrayToBeExported = tempClone;
                }
                else if (optionId === 1) {
                    for (var loopvariable = 0; loopvariable < this.props.colDefs2.length; loopvariable++) {

                        for (var children = 0; children < this.props.colDefs2[loopvariable].children.length; children++) {
                            if (exportColumns.indexOf(this.props.colDefs2[loopvariable].children[children].field) >= 0) {
                                //Exists, do nothing. be part of export array
                            }
                            else {
                                //not exists, removed from export array
                                // var b = r1[loopvariable].children;
                                tempClone2[loopvariable].children.splice(children, 1)
                                children = children - 1;
                            }
                        }
                    }
                    arrayToBeExported = tempClone2;
                }
                //arrayToBeExported = tempClone;
            }
            else {
                if (this.props.functionId == 66)
                    arrayToBeExported = this.props.colDefs;
                else
                    arrayToBeExported = this.props.colDefs2;
            }



            var uri;
            var sheetData = { HeaderData: [], ColumnData: [] };

            if (this.props.parentchild == 'P') {

                // Excel.InitializeExportParent(arrData, r, this.props.formName);
                uri = Excel.InitializeExportParentGridExportToXLSX(arrData, arrayToBeExported, this.props.formName);
                this.state.exportFields.ExportData = JSON.stringify(uri);
            } else {

                // Excel.InitializeExportParent(arrData, r, this.props.formName);
                uri = Excel.InitializeChildGridExportToExcel(arrData, arrayToBeExported, this.props.formName);
                this.state.exportFields.ExportData = JSON.stringify(uri);
            }

            sheetData = Excel.ConvertCSVToJSon(uri);
            //this.setState({ excelData: sheetData.ColumnData, headerData: sheetData.HeaderData }, () => this.downloadExcel(this.props.formName, true));
            this.setState({ excelData: sheetData.ColumnData, headerData: sheetData.HeaderData }, () => this.downloadExcel(this.GetExportFileName(), true));
        }
        else {
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "No Data to Export.");
        }
    }
    getFileName(formName: string) {
        var currentDate = new Date();
        return formName + (currentDate.getMonth() + 1) + currentDate.getDate() + currentDate.getFullYear() + currentDate.getHours() + currentDate.getMinutes() + currentDate.getSeconds(); //RCNG-1584
    }
    downloadExcel(formName: string, isFileDownload: boolean) {
        var currentDate = new Date();
        self.setState({
            fileTitle: formName + currentDate.getDate() + currentDate.getMonth() + currentDate.getFullYear() + currentDate.getHours() + currentDate.getMinutes() + currentDate.getSeconds(),
            isDownload: isFileDownload
        }, () => self.renderSheets());

        //this.renderSheets();
    }

    renderSheets() {
        this.setState({ sheetInfo: this.generateSheetInfo() }, () => this.checkToFileDownload());
    }

    checkToFileDownload() {
        if (this.state.isDownload) {
            $('#btnDownloadReeferExcel1').click();
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Data exported successfully.");
            this.closePopUp();

            this.props.closeModelDialog();
            this.setState({ isDownload: false });
        }
    }
    showMessageAndClosePopup() {
        if (this.state.isDownload) {
            //$('#btnDownloadReeferExcel1').click();
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Data exported successfully.");
            this.closePopUp();
            ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
            if (this.props.closeModelDialog != null && this.props.closeModelDialog != undefined)
                this.props.closeModelDialog();
            this.setState({ isDownload: false });
        }
    }

    getSheetInfo(headerName: string) {
        var headerInfo = headerName.replace(/\s+/g, '');
        var removeDotInHeader = headerInfo.split('.').join('');
        var removeNInHeader = removeDotInHeader.replace('/n', '');
        var removeHashInHeader = removeNInHeader.replace('#', '');
        var removeUTCInHeader = removeHashInHeader.replace('(UTC)', '');
        var finalHeaderColumn = removeUTCInHeader.replace('(°C)', '');
        return <Workbook.Column label={headerName} value={finalHeaderColumn} />;
    }

    generateSheetInfo() {
        var columnInfo = [];
        if (this.state.headerData != null && this.state.headerData.length > 0) {
            $.each(this.state.headerData, function (i, iVal) {
                var sheetObject = self.getSheetInfo(iVal.headerName);
                columnInfo.push(sheetObject);
            });
        }

        return <Workbook.Sheet data={this.state.excelData} name="Sheet1">
            {columnInfo}
        </Workbook.Sheet>;
    }

    static applySheetData(sheetData: any, formName: string) {
        self.setState({ excelData: sheetData.ColumnData, headerData: sheetData.HeaderData }, () => self.downloadExcel(formName == '' ? self.props.formName : formName, true));
    }

    GetExportFileName() {

        var FileName = this.props.formName;
        //RCNG-1584 start
        var ReeferId; var reefereList; var count;
        if (FileName == "ReeferHistoryGrid" || FileName == "ReeferHistory" || FileName == "ReeferMapGrid") {
            if (FileName == "ReeferMapGrid" && this.props.isMapHistory == "False")
                ReeferId = "ReeferGrid_";
            else {
                reefereList = this.props.gridData.filter((reeferID, i, arr) => {
                    return arr.indexOf(arr.find(t => t.ReeferID === reeferID.ReeferID)) === i;
                });
                count = reefereList.length;

                if (count > 1)
                    ReeferId = "Multiple" + "_ReeferHistoryGrid_";
                else
                    ReeferId = reefereList[0].ReeferID + "_ReeferHistoryGrid_";

            }
        }//End
        // Start RCNG-1585
        else if (FileName == "GensetHistoryGrid" || FileName == "GensetHistory" || FileName == "GensetMap") {
            if (FileName == "GensetMap" && this.props.isMapHistory == "False")
                ReeferId = "GensetGrid_";
            else {
                reefereList = this.props.gridData.filter((reeferID, i, arr) => {
                    return arr.indexOf(arr.find(t => t.AssetNumber === reeferID.AssetNumber)) === i;
                });
                count = reefereList.length;

                if (count > 1)
                    ReeferId = "Multiple" + "_GensetHistoryGrid_";
                else
                    ReeferId = reefereList[0].AssetNumber + "_GensetHistoryGrid_";

            }
        }
        //End
        //Start RCNG-1587
        else if (FileName == "ChassisHistoryGrid" || FileName == "ChassisHistory" || FileName == "ChassisMap") {
            if (FileName == "ChassisMap" && this.props.isMapHistory == "False")
                ReeferId = "ChassisGrid_";
            else {
                reefereList = this.props.gridData.filter((reeferID, i, arr) => {
                    return arr.indexOf(arr.find(t => t.AssetNumber === reeferID.AssetNumber)) === i;
                });
                count = reefereList.length;

                if (count > 1)
                    ReeferId = "Multiple" + "_ChassisHistoryGrid_";
                else
                    ReeferId = reefereList[0].AssetNumber + "_ChassisHistoryGrid_";

            }
        } //End
        //RCNG-1586 start
        else if (FileName == "DryHistoryGrid" || FileName == "DryHistory" || FileName == "DryMap") {
            if (FileName == "DryMap" && this.props.isMapHistory == "False")
                ReeferId = "DryGrid_";
            else {
                reefereList = this.props.gridData.filter((reeferID, i, arr) => {
                    return arr.indexOf(arr.find(t => t.AssetNumber === reeferID.AssetNumber)) === i;
                });
                count = reefereList.length;

                if (count > 1)
                    ReeferId = "Multiple" + "_DryHistoryGrid_";
                else
                    ReeferId = reefereList[0].AssetNumber + "_DryHistoryGrid_";

            }
        }
        //End
        switch (FileName) {
            //1. Reefers
            case "ReeferGrid":
                return "ReeferGrid_";  //RCNG-1584
            case "ReeferStatusGrid":
                return "ReeferGrid_";  //RCNG-1584
            case "ReeferMapGrid":
                return ReeferId;  //RCNG-1584
            case "ReeferHistoryGrid":
                return ReeferId;  //RCNG-1584
            case "ReeferHistory":  //RCNG-1584
                return ReeferId;


            //2. Gensets
            case "GensetHistoryGrid":
                return ReeferId;    //RCNG - 1585
            case "GensetHistory":   //RCNG - 1585
                return ReeferId;
            case "GensetMap":
                return ReeferId;     //RCNG - 1585
            case "GensetStatusGrid":
                return "GensetGrid_";  //RCNG - 1585
            case "GensetStatus":
                return "GensetGrid_";  //RCNG - 1585

            //3. Drys
            case "DryStatusGrid":
                return "DryGrid_"; //RCNG-1586
            case "DryHistoryGrid":
                return ReeferId;  //RCNG-1586
            case "DryHistory":
                return ReeferId;  //RCNG-1586
            case "DryMap":
                return ReeferId;  //RCNG-1586
            case "DryStatus":
                return "DryGrid_"; //RCNG-1586


            //4. Chassis
            case "ChassisStatusGrid":
                return "ChassisGrid_";//RCNG-1587
            case "ChassisHistoryGrid":
                return ReeferId;//RCNG-1587
            case "ChassisHistory":  //RCNG-1587
                return ReeferId;
            case "ChassisMap":
                return ReeferId; //RCNG-1587
            case "ChassisStatus":
                return "ChassisGrid_";//RCNG-1587

            default:
                return FileName;
        }

    }
}

export class ExportToExcelConfirmWindow extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }
    static close() {
        $("#confirmPopUpModel .btn-close").click();
    }
    static showConfirmBox(Message, OkMethod, cancelMethod, FunctionID, gridData, colDefs, formName, parentchild) {

        ReactDom.render(<ExportToExcelConfirmationWindow Message={Message} OkMethod={OkMethod} cancelMethod={cancelMethod} FunctionID={FunctionID}
            gridData={gridData} colDefs={colDefs} formName={formName} parentchild={parentchild}
        />, document.getElementById('divMsboxDynamicContent'));
        setTimeout(function () {
            $('#confirmPopUpModel').show();
        }, 50);
    }

    public render() {
        return <div >
        </div>
    }
}